import { Button, Card, CardContent, Typography } from "@mui/material";
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { useState } from "react";
import i18next from "i18next";
import imgurl from "../assests/images/imgurl";
import { useSelector } from "react-redux";

const ReportContentMaster = ({keyName}) => {

  const locale = useSelector((state) => state.language.langData);

  const [masterJsonEn] = useState({
    male_photos_description_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos show a healthy scalp with uniform hair density across all regions. The hairline is full, with no visible thinning at the temples, crown.   
          </Typography>
          <Typography className="description mt-10px">
            Shedding of up to one hundred hairs per day is normal and part of the natural growth cycle. Temporary increases in shedding may occur during seasonal changes, illness, or periods of stress. These variations do not indicate pathological hair loss.  
          </Typography>
          <Typography className="description mt-10px">
            The hair structure and follicular activity appear balanced, with no visible irregularities. Preventive care and regular monitoring help preserve scalp health and maintain natural density over time. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens </h3>
          </div>
          <Typography className="description">
            Even when the scalp looks normal, the biological mechanisms that control hair growth remain active below the surface. 
          </Typography>
          <ul>
            <li>
              After puberty, circulating testosterone is partially converted into DHT (dihydrotestosterone) by the enzymes 5-alpha-reductase types I and II. 
            </li>
            <li>
              In individuals with a hereditary sensitivity, DHT binds to receptors in the hair follicles and gradually reduces their diameter and growth potential. 
            </li>
            <li>
              This process, called follicular miniaturisation, shortens the growth phase (anagen) and lengthens the resting phase (telogen), leading to finer hair shafts if it progresses unchecked. 
            </li>
          </ul>
          <Typography className="description">
            Maintaining healthy follicles through balanced nutrition and appropriate scalp care supports stable density and helps delay early changes that lead to alopecia. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage0 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>Preventive medical treatment may be recommended if you have a family history of hair loss or if microscopic thinning is already detected.</li>
          <li>Lifestyle optimisation is critical at this stage to support follicle health and delay visible loss.</li>
          <li>Patients who begin preventive treatment at stage 1 often maintain natural density for years, reducing the likelihood of progression.</li>
        </ul>
        {/* <Typography className="description mt-10px">
          Next Steps: Access Prescription - Only Treatment
        </Typography> */}
      </>
    ),
    male_timeline_stage0 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with preventive care</h3>
          </div>
          <ul>
            <li>
              Month 1: Density maintained. 
            </li>
            <li>
              Months 3–6: No visible changes; subtle improvements in follicle strength possible.
            </li>
            <li>
              Months 6–12: Long-term monitoring ensures that any early changes are detected and treated quickly.
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <Typography className="description">At this early stage, supportive care can suffice to keep follicles resilient. It consists of appropriate nutrition and scalp care.</Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required. There are vitamins and micronutrients that are essential:</Typography>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes</li>
              <li>Zinc — which is found in chickpeas, cashews, oysters, lentils</li>
              <li>Iron — also present in lentils and chickpeas, as well as shellfish and meat</li>
              <li>Vitamin D and A — essential for follicle metabolism</li>
            </ul>
          </ul>
          <ul>
            <li> Scalp care </li>
            <Typography className="description">You must take good care of your scalp and avoid trauma of all kinds.</Typography>
            <ul>
              <li>Gentle daily massage with a silicone massager (available on this site) will improve circulation and follicle health.</li>
              <li>Avoid dyeing your hair with harsh chemicals, do not use hot dryers, and avoid hairstyles that pull strongly on your hair.</li>
              <li>
                Use a shampoo based on natural products that have mild anti-DHT activity — ayurvedic (bhringraj oil, amla oil) or essential oils such as saw palmetto, tea tree, rosemary, or pumpkin seed.  
              </li>
            </ul>
          </ul>
          <ul>
            <li>Lifestyle</li>
            <ul>
              <li>Avoid smoking, as it accelerates hair thinning.</li>
              <li>Ensure sufficient sleep.</li>
              <li>Track progress: Take scalp photos every 6–12 months. This builds a clear record to identify changes over time.</li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage0 : (
      <Card className="statCard yourPhotossection legalSection stage1">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos show some thinning around the temples. The hairline looks slightly receded on the sides, while the rest of your hair remains full and dense. This difference suggests a gradual change.
          </Typography>
          <Typography className="description mt-10px">
            It’s important to remember that this type of change is common and should not be seen as alarming. In most cases, hair thinning has an identifiable cause and can be improved with the right care. Only a professional can give you a clear diagnosis and recommend the most effective solution. You can request a free consultation with a hair specialist directly on this site.
          </Typography>
          <Typography className="description mt-10px">
            Many everyday factors influence hair health: lifestyle, stress, fatigue, diet, and daily habits. If your body doesn’t get enough essential nutrients, your hair may become more fragile. That’s why maintaining a balanced diet is so important. To strengthen this, you can order a specific vitamin supplement by clicking HERE.
          </Typography>
          <Typography className="description mt-10px">
            Simple habits can also help slow down the process: avoid tight hairstyles, choose gentle shampoos without harsh ingredients (like sulphates, parabens, silicones, or formaldehyde), limit the use of hot blowdrying, and stimulate circulation with regular scalp massage. A daily massage using a silicone scalp massager (available HERE) boosts blood flow, supports stronger roots, and helps improve hair density.
          </Typography>
          <Typography className="description mt-10px">
            It’s also worth noting that smoking is a major aggravating factor. By reducing circulation and accelerating aging, it can double the risk of hereditary hair loss in heavy smokers. Taking action here is another step toward healthier hair. 
          </Typography>
          <Typography className="description mt-10px">
            At this stage, the most important step is to benefit from a professional consultation. A specialist can review your photos, provide a clear assessment, and suggest a plan tailored to your situation. This is the key to turning concern into a concrete solution. 
          </Typography>
          <Typography className="description bold mt-10px">
            Don’t let hair loss progress without taking action. Request your free consultation today. You’ll receive personalized advice and, if needed, a prescription to protect and preserve your hair. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            In many cases, hair loss is driven by a genetic sensitivity to a hormone called DHT (dihydrotestosterone). If male relatives in your family have experienced balding, your hair follicles may be more vulnerable to this hormone.
          </Typography>
          <ul>
            <li>
              After puberty, testosterone levels rise. About 10 % of that testosterone is converted into DHT by two enzymes: 5-alpha-reductase type I and II. 
            </li>
            <li>
              In sensitive individuals, DHT binds to receptors in the hair follicles and causes them to shrink gradually. 
            </li>
            <li>
              This leads to thinner, weaker hair strands, a shortened growth phase (anagen), and more follicles entering a resting phase (telogen) — resulting in increased shedding and slower regrowth.  
            </li>
            <li>
              Over time, some follicles may become inactive, losing the ability to produce hair altogether.  
            </li>
            <li>
              Some areas of the scalp have a higher density of DHT receptors than others, notably the temples and crown, which explains why male pattern hair loss usually starts in these zones. 
            </li>
          </ul>
          <Typography className="description mt-10px">
            Because these changes are still mild and localised at this grade, preventive and medical intervention can effectively stabilise shedding and protect follicle function. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage1 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>A doctor may prescribe a DHT-blocking therapy to slow miniaturisation and preserve density.</li>
          <li>Support the treatment with consistent scalp care and nutritional support.</li>
          <li>Follow-up every 2 – 3 months with photos to monitor stability and response.</li>
          {/* <li>Patients who begin treatment at this stage often see stabilisation and visible restoration of fullness within months. </li> */}
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    male_timeline_stage1 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1: Hair loss begins to stabilize; shedding may decrease.   
            </li>
            <li>
              Months 3–6: Follicles in the temple region begin producing stronger, thicker hairs.  
            </li>
            <li>
              Months 6–12: Visible restoration of the hairline contour and improved density.  
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <Typography className="description">
            At this early stage, supportive care can suffice to keep follicles resilient. It consists of appropriate nutrition and scalp care.  
          </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">
              A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required. There are vitamins and micronutrients that are essential: 
            </Typography>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes</li>
              <li>Zinc — which is found in chickpeas, cashews, oysters, lentils</li>
              <li>Iron — also present in lentils and chickpeas, as well as shellfish and meat </li>
              <li>Vitamin D and A — essential for follicle metabolism </li>
            </ul>
          </ul>
          <ul>
            <li>Scalp care</li>
            <Typography className="description">
              You must take good care of your scalp and avoid trauma of all kinds.
            </Typography>
            <ul>
              <li>
                Gentle daily massage with a silicone massager (available on this site) will improve circulation and follicle health.  
              </li>
              <li>
                Avoid dyeing your hair with harsh chemicals, do not use hot dryers, and avoid hairstyles that pull strongly on your hair. 
              </li>
              <li>
                Use a shampoo based on natural products that have mild anti-DHT activity — ayurvedic (bhringraj oil, amla oil) or essential oils such as saw palmetto, tea tree, rosemary, or pumpkin seed.
              </li>
            </ul>
          </ul>
          <ul>
            <li>Lifestyle</li>
            <ul>
              <li>Avoid smoking, as it accelerates hair thinning.</li>
              <li>Ensure sufficient sleep.</li>
              <li>Track progress: Upload scalp photos every 6–12 months. This builds a clear record to identify changes over time.</li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage1 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos show a clear recession of the hairline at the temples. The frontal hairline has moved back noticeably, while the rest of your hair still maintains good density on most of the scalp. This pattern is typical of a progressive change that deserves attention.
          </Typography>
          <Typography className="description mt-10px">
            It is important to understand that this situation is common and should not be seen as alarming, but the volume of hair loss probably requires attention. In most cases, hair loss has an identifiable medical cause and can be improved with the right treatment. Only a specialist can provide a precise assessment and recommend the most effective solution. You can request a free consultation with a hair expert directly on this site and you should no wait. 
          </Typography>
          <Typography className="description mt-10px">
            Many everyday factors also influence hair health: lifestyle, stress, fatigue, diet, and daily habits. If your body does not receive enough essential nutrients, notably vitamins and zinc, your hair may become more fragile. Maintaining a balanced diet is therefore essential. To strengthen this, you can order a specific vitamin supplement by clicking HERE. 
          </Typography>
          <Typography className="description mt-10px">
            Simple habits can also help slow down the process: avoid tight hairstyles, choose gentle shampoos without harsh ingredients (such as sulphates, parabens, silicones, or formaldehyde), limit the use of hot blowdrying, and stimulate circulation with regular scalp massage. A daily massage using a silicone scalp massager (available HERE) boosts blood flow, supports stronger roots, and helps improve hair density. 
          </Typography>
          <Typography className="description mt-10px">
            It is also worth noting that smoking is a major aggravating factor. By reducing circulation and accelerating aging, it can double the risk of hereditary hair loss in heavy smokers. Taking action here is another step toward healthier hair.  
          </Typography>
          <Typography className="description mt-10px">
            At this stage, the most important step is to benefit from a professional consultation. A specialist can review your photos, provide a clear assessment, and suggest a plan tailored to your situation. This is the key to turning concern into a concrete solution.  
          </Typography>
          <Typography className="description bold mt-10px">
            Do not let hair loss progress without taking action. Request your free consultation today. You will receive personalized advice and a prescription to protect and preserve your hair.   
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            In many cases, hair loss is driven by a genetic sensitivity to a hormone called DHT (dihydrotestosterone). If male relatives in your family have experienced balding, your hair follicles may be more vulnerable to this hormone.  
          </Typography>
          <ul>
            <li>
              After puberty, testosterone levels rise. About 10 % of that testosterone is converted into DHT by two enzymes: 5-alpha-reductase type I and II. 
            </li>
            <li>
              In sensitive individuals, DHT binds to receptors in the hair follicles and causes them to shrink gradually.   
            </li>
            <li>
              This leads to thinner, weaker hair strands, a shortened growth phase (anagen), and more follicles entering a resting phase (telogen) — resulting in increased shedding and slower regrowth.   
            </li>
            <li>
              Over time, some follicles may become inactive, losing the ability to produce hair altogether. 
            </li>
            <li>
              Some areas of the scalp have a higher concentration of DHT receptors, particularly at the temples and crown, which explains why male pattern baldness typically begins there.
            </li>
          </ul>
          <Typography className="description">
            At this grade, follicles remain active but visibly miniaturised. With early medical care, the process can often be stabilised, and partial regrowth is possible.   
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage2 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        {/* <Typography className="description">
          You should begin a clinically proven, doctor-prescribed DHT-blocking treatment, often combined with targeted peptides. These therapies:
        </Typography> */}
        <ul>
          <li>A doctor may prescribe a DHT-blocking therapy (topical or oral) to protect vulnerable follicles and slow progression.</li>
          <li>Combine treatment with a consistent scalp-care routine and balanced nutrition to improve response.</li>
          <li>Repeat photo monitoring every 2 – 3 months to track density changes.</li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
        {/* <Typography className="description">
          A licensed doctor will review your case, confirm the stage, and prescribe the most effective treatment plan.
        </Typography> */}
      </>
    ),
    male_timeline_stage2 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment</h3>
          </div>
          <ul>
            <li>
              Month 1: Hair loss begins to stabilize; shedding may decrease.  
            </li>
            <li>
              Months 3–6: Follicles in the temple region begin producing stronger, thicker hairs. 
            </li>
            <li>
              Months 6–12: Visible restoration of the hairline contour and improved density. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <Typography className="description"> 
            At this early stage, supportive care can suffice to keep follicles resilient. It consists of appropriate nutrition and scalp care. 
          </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description"> 
              A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required. There are vitamins and micronutrients that are essential: 
            </Typography>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes</li>
              <li>Zinc — which is found in chickpeas, cashews, oysters, lentils</li>
              <li>Iron — also present in lentils and chickpeas, as well as shellfish and meat</li>
              <li>Vitamin D and A — essential for follicle metabolism </li>
            </ul>
          </ul>
          <ul>
            <li>Scalp care</li>
            <Typography className="description"> 
              You must take good care of your scalp and avoid trauma of all kinds. 
            </Typography>
            <ul>
              <li>Gentle daily massage with a silicone massager (available on this site) will improve circulation and follicle health.</li>
              <li>Avoid dyeing your hair with harsh chemicals, do not use hot dryers, and avoid hairstyles that pull strongly on your hair.</li>
              <li>Use a shampoo based on natural products that have mild anti-DHT activity — ayurvedic (bhringraj oil, amla oil) or essential oils such as saw palmetto, tea tree, rosemary, or pumpkin seed. </li>
            </ul>
          </ul>
          <ul>
            <li>Lifestyle</li>
            <ul>
              <li>Avoid smoking, as it accelerates hair thinning.</li>
              <li>Ensure sufficient sleep.</li>
              <li>Track progress: Upload scalp photos every 6–12 months. This builds a clear record to identify changes over time. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage2 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a noticeable transformation: the hairline has deeply receded at the temples, and thinning is visible across the crown. The sides and back remain relatively strong, but the contrast between these areas and the front is clear. 
          </Typography>
          <Typography className="description mt-10px">
            This stage often marks a turning point. Hair loss is no longer subtle—it is visible and progressive. While common, it should not be ignored. Most cases of hair losses have a medical explanation, even if heredity may play an important role. Many men experience this pattern of hair loss, and effective solutions exist to slow, stop, or even reverse the process.
          </Typography>
          <Typography className="description mt-10px">
            A medical specialist can analyse your photos in detail and bring up a diagnosis.  A free medical consultation would help you understand your situation and its possible evolution. Prescription of an appropriate treatment will also be available, if needed. 
          </Typography>
          <Typography className="description mt-10px">
            Stress, fatigue, poor sleep, smoking, and unbalanced nutrition all accelerate hair changes. Strengthening your daily routine—better rest, healthier diet, and reduced exposure to harmful habits—can make a difference. Supplements, based on specific vitamins and zinc, and designed for hair vitality (click HERE) provide additional support.  
          </Typography>
          <Typography className="description mt-10px">
            In addition, stimulate blood circulation with a daily scalp massage. A silicone massager (available HERE) is a practical tool to boost blood flow and encourage stronger hair roots. Its daily usage supports the follicles that are not in sleeping mode and prevent worsening of the hair loss. 
          </Typography>
          <Typography className="description mt-10px">
            The most important action now is to seek expert guidance. A consultation will give you clarity, a tailored plan, and the confidence that you are addressing the issue at the right time. Do not wait for further progression.  
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            Hair loss at this level results from long-term sensitivity of the follicles to DHT (dihydrotestosterone), a derivative of testosterone. 
          </Typography>
          <ul>
            <li>
              After puberty, testosterone levels rise, and about 10 % of that testosterone is converted into DHT by the enzymes 5-alpha-reductase type I and II. 
            </li>
            <li>
              In genetically sensitive men, DHT binds to specific receptors in the follicles, gradually reducing their size and weakening their ability to produce strong hair shafts.  
            </li>
            <li>
              The growth (anagen) phase becomes shorter, and the resting (telogen) phase lengthens, leading to slower regrowth and increased shedding.  
            </li>
            <li>
              The growth (anagen) phase becomes shorter, and the resting (telogen) phase lengthens, leading to slower regrowth and increased shedding.   
            </li>
            <li>
              The temples and crown contain a higher concentration of DHT receptors, which is why these regions thin first and then merge into a single zone of visible baldness.   
            </li>
          </ul>
          <Typography className="description">
            At this grade, many follicles are still viable. Treatment focused on reducing the action of DHT and supporting follicular metabolism can stabilise or even partially reverse the process.  
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage3 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>
            A physician may prescribe a DHT-blocking treatment (topical or oral) to limit the hormone’s effect on sensitive follicles.  
          </li>
          <li>Peptide-based or growth-supporting treatments can complement the medical approach by improving shaft quality and scalp health. </li>
          <li>Regular follow-up every 2–3 months with photographic comparison allows objective monitoring of results. </li>
          {/* <li>Without medical treatment, progression to Stage 5 and beyond is highly likely. </li> */}
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    male_timeline_stage3 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1: Hair loss begins to stabilize; shedding may decrease.
            </li>
            <li>
              Months 3–6: Follicles in the temple region begin producing stronger, thicker hairs. 
            </li>
            <li>
              Months 6–12: Visible restoration of the hairline contour and improved density. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <Typography className="description"> 
            At this early stage, supportive care can suffice to keep follicles resilient. It consists of appropriate nutrition and scalp care.
          </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">
              A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required. There are vitamins and micronutrients that are essential: 
            </Typography>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes</li>
              <li>Zinc — which is found in chickpeas, cashews, oysters, lentils</li>
              <li>Iron — also present in lentils and chickpeas, as well as shellfish and meat </li>
              <li>Vitamin D and A — essential for follicle metabolism </li>
            </ul>
          </ul>
          <ul>
            <li>Scalp care</li>
            <Typography className="description">
              You must take good care of your scalp and avoid trauma of all kinds. 
            </Typography>
            <ul>
              <li>Gentle daily massage with a silicone massager (available on this site) will improve circulation and follicle health.</li>
              <li>Avoid dyeing your hair with harsh chemicals, do not use hot dryers, and avoid hairstyles that pull strongly on your hair. </li>
              <li>Use a shampoo based on natural products that have mild anti-DHT activity — ayurvedic (bhringraj oil, amla oil) or essential oils such as saw palmetto, tea tree, rosemary, or pumpkin seed. </li>
            </ul>
          </ul>
          <ul>
            <li>Lifestyle</li>
            <ul>
              <li>Avoid smoking, as it accelerates hair thinning.</li>
              <li>Ensure sufficient sleep.</li>
              <li>Track progress: Take scalp photos every 6–12 months. This builds a clear record to identify changes over time. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage3 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos show the most advanced stage of hair loss. The frontal hairline has completely disappeared, and the thinning at the crown has expanded until the entire top of the scalp is bare. Only the sides and back retain coverage, forming a horseshoeshaped band of hair.
          </Typography>
          <Typography className="description mt-10px">
            This is the end stage of male pattern baldness. There is no disguising it: the top of the scalp has very little or no hair left. Many men reach this point believing that nothing can be done. While restoration is not realistic, effective options still exist to improve appearance, and our medical specialists can review your photos and indicate what solutions are open to you. 
          </Typography>
          <Typography className="description mt-10px">
            Even at this stage, taking action matters. A consultation can help you understand what is possible, whether it’s stabilizing the sides and back, exploring cosmetic or surgical options, or simply receiving professional guidance on how to manage the situation with confidence.  
          </Typography>
          <Typography className="description mt-10px">
            A free professional consultation is available. A specialist can review your photos, explain the realistic options available, and design a plan suited to your situation. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            Hair loss at this level results from long-term exposure of genetically sensitive follicles to DHT (dihydrotestosterone), a hormone derived from testosterone.  
          </Typography>
          <ul>
            <li>
              After puberty, circulating testosterone is partly converted into DHT by the enzymes 5-alpha-reductase type I and II.  
            </li>
            <li>
              In sensitive follicles on the top of the scalp, DHT binds to receptors that gradually reduce the follicle’s diameter and weaken its growth capacity. 
            </li>
            <li>
              The growth (anagen) phase becomes shorter, and the resting (telogen) phase lengthens, producing finer and shorter hairs.  
            </li>
            <li>
              With time, some follicles become dormant and stop forming visible hair shafts. 
            </li>
            <li>
              Follicles on the back and sides contain fewer DHT receptors and therefore remain largely unaffected.   
            </li>
          </ul>
          <Typography className="description">
            At this advanced grade, medical treatment can help maintain the remaining follicles, while restorative options may be considered for coverage improvement.  
          </Typography>
        </CardContent>
      </Card>
    ),
    male_options_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Hair Transplant and Supportive Options </h3>
          </div>
          <Typography className="description">
            When hair thinning reaches this grade, medical treatment alone may offer only limited improvement where follicles are already inactive. 
            Options to discuss with a qualified specialist include: 
          </Typography>
          <Typography className="description mt-10px">
            Hair Transplantation
          </Typography>
          <ul>
            <li>
              FUT (Follicular Unit Transplantation): a narrow strip of scalp from the donor area is dissected into grafts and implanted into thinning zones.</li>
            <li>
              FUE (Follicular Unit Extraction): individual grafts are harvested one by one from the donor area and implanted where coverage is lacking.
            </li>
          </ul>
          <Typography className="description">
            Both techniques can provide natural, lasting results when performed by an experienced surgeon.
          </Typography>
          <Typography className="description">
            The choice depends on donor density, scalp condition, and personal expectations. 
          </Typography>
          <Typography className="description mt-10px">
            Supportive Care
          </Typography>
          <Typography className="description">
            Supportive therapies may help preserve remaining follicles and improve scalp health even where full regrowth is no longer possible. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_to_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">What to Expect </h3>
          </div>
          <ul>
            <li>
              After a successful transplant, coverage can approximate Grade 2–3 density. 
            </li>
            <li>
              Additional sessions may be required if donor supply allows.   
            </li>
            <li>
              Ongoing prescription DHT-blocking therapy can help maintain both native and transplanted follicles. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage4 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>Immediate prescription therapy is required — a DHT blocker remains the cornerstone of treatment.</li>
          <li>Peptides and supportive therapies can help improve the thickness and quality of remaining hair.</li>
          <li>In some cases, a hair transplant may also be considered, particularly for areas bald for a long time. </li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    male_timeline_stage4 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1: Hair loss begins to stabilize; shedding may decrease. 
            </li>
            <li>
              Months 3–6: Follicles in the temple region begin producing stronger, thicker hairs.  
            </li>
            <li>
              Months 6–12: Visible restoration of the hairline contour and improved density.  
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          {/* <Typography className="description">
            At this early stage, supportive care can suffice to keep follicles resilient. It consists of appropriate nutrition and scalp care.
          </Typography> */}
          <ul>
            <li>Nutrition</li>
            <Typography className="description">
              Even at this grade, hair and scalp health benefit from proper nutrition:  
            </Typography>
            <ul>
              <li>Protein: essential for keratin synthesis.</li>
              <li>Biotin: egg yolks, almonds, peanuts, sweet potatoes.</li>
              <li>Zinc: chickpeas, cashews, oysters, lentils. </li>
              <li>Iron: lentils, chickpeas, shellfish, lean meat.</li>
              <li>Vitamins D and A: support scalp renewal and follicular metabolism.</li>
            </ul>
          </ul>
          <ul>
            <li>Scalp care</li>
            {/* <Typography className="description">
              You must take good care of your scalp and avoid trauma of all kinds.
            </Typography> */}
            <ul>
              <li>Gently massage the scalp daily to maintain micro-circulation. </li>
              <li>Use a mild, sulfate-free shampoo with botanical extracts such as rosemary, bhringraj, or saw palmetto. </li>
              <li>Avoid aggressive treatments and excessive heat exposure. </li>
            </ul>
          </ul>
          <ul>
            <li>Lifestyle</li>
            <ul>
              <li>Adequate rest and stress management are essential to maintain scalp health. </li>
              <li>Avoid smoking, as it limits oxygen delivery and worsens thinning. </li>
              <li>Monitor progress and review options with a licensed physician if you consider medical or surgical interventions. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage4 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos reveal extensive balding across the top of the scalp, with the hairline recession and crown thinning now fully merged. Only sparse, fragile strands remain through the mid-scalp, and they no longer provide cosmetic coverage.  
          </Typography>
          <Typography className="description mt-10px">
            At this stage, your androgenetic alopecia has progressed to the point where medical treatments alone may offer only limited results. In areas where hair is already absent, the follicles have likely undergone irreversible changes and may no longer respond to therapies that target 5-alpha-reductase enzymes, which are responsible for producing DHT (dihydrotestosterone).  
          </Typography>
          <Typography className="description mt-10px">
            However, clinical studies have shown that advanced medical treatments can still improve hair density in regions where some follicles remain active — even in men at this stage of hair loss. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            The biology of hair loss at Stage 6 is driven by the long-term destructive effect of DHT (dihydrotestosterone) on genetically sensitive follicles.  
          </Typography>
          <ul>
            <li>
              From puberty onward, about 10% of testosterone is converted into DHT by the enzymes 5-alpha-reductase type I and II. </li>
            <li>
              In individuals with androgenetic alopecia, DHT binds to receptors in follicles across the crown, mid-scalp, and frontal hairline. 
            </li>
            <li>
              This binding disrupts follicle activity in several ways: 
              <ul>
                <li>
                  The follicle shaft shrinks with each growth cycle (miniaturization).
                </li>
                <li>
                  The anagen (growth) phase shortens, so hairs don’t grow as long or thick. 
                </li>
                <li>
                  The telogen (resting) phase lengthens, leading to increased shedding.
                </li>
                <li>
                  Blood supply and nutrient delivery to the follicle are progressively reduced.
                </li>
              </ul>
            </li>
            <li>
              By Stage 6, the majority of follicles in the affected zones have been dormant for multiple cycles. These follicles are no longer capable of producing hair, even if DHT levels are suppressed.
            </li>
            <li>
              However, the donor zone at the back and sides of the scalp remains resistant to DHT and continues to grow healthy hair. These donor follicles are the foundation for hair transplantation procedures. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage6 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <Typography className="description">
          If your goal is to restore coverage in visibly bald areas, a hair transplant iscurrently the most effective solution. There are two primary techniques: 
        </Typography>
        <ul>
          <li>
            FUT (Follicular Unit Transplantation): A strip of scalp is removed from a donorarea, and individual follicular units are transplanted. </li>
          <li>
            FUE (Follicular Unit Extraction): Individual follicles are harvested directly fromthe donor area and implanted into the balding zones. 
          </li>
        </ul>
        <Typography className="description mt-10px">
          Both methods have their own advantages and limitations, and the choice depends on yourscalp condition, donor hair availability, and personal preferences. When performed bya skilled and experienced surgeon, success rates typically exceed 90%. 
        </Typography>
        <Typography className="description mt-10px">
          The cost of a transplant depends on the number of follicles required, and multiplesessions may be recommended to achieve optimal coverage and natural-looking results. 
        </Typography>
        <ul>
          <li>
            Peptide-based therapies can support follicle strength, scalp health, andpost-transplant recovery. 
          </li>
        </ul>
        {/* <Typography className="description mt-10px">
          Next Steps: Access Prescription - Only Treatment
        </Typography> */}
      </>
    ),
    male_what_to_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">What to Expect </h3>
          </div>
          <ul>
            <li>
              After one transplant, coverage may resemble Norwood stage 3 or 4
            </li>
            <li>
              For greater density, additional sessions may be necessary 
            </li>
            <li>
              To maintain results and protect transplanted follicles, prescription DHT blockers may help protect donor follicles and ensure transplanted grafts remain healthy.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    // male_timeline_stage6 : (
    //   <Card className="statCard yourPhotossection">
    //      <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <AccessTimeOutlinedIcon className="cameraIcon" />
    //         <h3 className="photoTitle">Expected timeline with treatment </h3>
    //       </div>
    //       <ul>
    //         <li>
    //           Month 1:  density maintained. 
    //         </li>
    //         <li>
    //           Months 3–6:  No visible changes; subtle improvements in follicle strepossible.
    //         </li>
    //         <li>
    //           Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
    //         </li>
    //       </ul>
    //      </CardContent>
    //   </Card>
    // ),
    // male_lifestyle_stage6 : (
    //   <Card className="statCard yourPhotossection">
    //     <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <h3 className="photoTitle">Lifestyle & daily care support </h3>
    //       </div>
    //       <Typography className="description">While surgery and prescription therapy are the cornerstones, lifestyle choices remain important to support outcomes: </Typography>
    //       <ul>
    //         <li>Nutrition: </li>
    //         <ul>
    //           <li> Biotin — egg yolks, almonds, peanuts, sweet potatoes</li>
    //           <li>Zinc — lentils, cashews, chickpeas, oysters</li>
    //           <li>Vitamins A, D, and E — help strengthen scalp and follicle environment </li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li> Scalp Stimulation:</li>
    //         <ul>
    //           <li>Gentle scalp massage with a silicone massager, 5 minutes daily, improves circulation and aids healing post-transplant.</li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li>Avoid: Smoking, excessive alcohol, chemical styling treatments, and direct trauma to the scalp after surgery. </li>
    //       </ul>
    //       <ul>
    //         <li>Track Progress: Post-transplant regrowth begins at 3–4 months, with major density improvements by 9–12 months. Uploading photos every 3 months through the app ensures accurate tracking. </li>
    //       </ul>
    //     </CardContent>
    //   </Card>
    // ),
    male_legal_stage6 : (
      <Card className="statCard yourPhotossection legalSection stage1">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos reveal end-stage androgenetic alopecia. The entire top of the scalp, including the hairline, mid-scalp, and crown, is bald, with only a narrow horseshoe-shaped band of hair remaining along the back and sides.
          </Typography>
          <Typography className="description mt-10px">
            Advanced baldness requires surgical restauration of coverage
          </Typography>
          <Typography className="description mt-10px">
            You’ve reached Norwood stage 7, hair loss is extensive — but a transplant is still a viable option. At this stage, surgeons may need to harvest follicles from alternative donor sites, such as the beard, chest, or back, especially if scalp donor areas are limited.
          </Typography>
        </CardContent>
      </Card>
    ),
    // male_why_stage7 : (
    //   <Card className="statCard yourPhotossection">
    //     <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <h3 className="photoTitle"> Why this happens</h3>
    //       </div>
    //       <Typography className="description">
    //         Stage 7 occurs because of the long-term, cumulative impact of DHT (dihydrotestosterone) on genetically sensitive follicles over many years.  
    //       </Typography>
    //       <ul>
    //         <li>From puberty onward, testosterone is partially converted into DHT by 5-alpha-reductase type I and II. </li>
    //         <li>
    //           In men with androgenetic alopecia, DHT binds strongly to receptors in follicles across the entire top of the scalp. 
    //         </li>
    //         <li>
    //           This results in repeated miniaturization cycles:
    //           <ul>
    //             <li>
    //               Hair shafts become progressively thinner and weaker. 
    //             </li>
    //             <li>
    //               The growth (anagen) phase shortens, so new hairs cannot reach full length or density. 
    //             </li>
    //             <li>
    //               The resting (telogen) phase dominates, increasing shedding and preventing replacement growth.
    //             </li>
    //           </ul>
    //         </li>
    //         <li>
    //           After multiple cycles, a large proportion of follicles become completely inactive, with no capacity to produce new hair. 
    //         </li>
    //         <li>
    //           By Stage 7, the only remaining active follicles are located in the donor zone at the back and sides, which are genetically resistant to DHT. These hairs form the basis for transplantation, but donor supply is often limited compared to the size of the bald area. 
    //         </li>
    //       </ul>
    //     </CardContent>
    //   </Card>
    // ),
    male_what_stage7 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>
            Combined transplant techniques 
            <ul>
              <li>
                FUT is often used for harvesting from the occipital region, where donor hair is typically more robust. 
              </li>
              <li>
                FUE may be combined to extract follicles from non-scalp areas, allowing for broader coverage. 
              </li>
            </ul>
          </li>
        </ul>
        <Typography className="description mt-10px">
          Transplants at this stage may require 5,000 follicles or more, making the procedure more complex and relatively costly. Pricing depends on: 
        </Typography>
        <ul>
          <li>The number of follicles transplanted </li>
          <li>The technique used </li>
          <li>The experience and reputation of the surgeon </li>
        </ul>
        {/* <Typography className="description mt-10px">
          Next Steps: Access Prescription - Only Treatment
        </Typography> */}
      </>
    ),
    male_what_to_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">What to Expect</h3>
          </div>
          <ul>
            <li>
              After one transplant, coverage may resemble Norwood stage 3 or 4  
            </li>
            <li>
              For greater density, additional sessions may be necessary  
            </li>
            <li>
              To maintain results and protect transplanted follicles, prescription DHT blockers may help protect donor follicles and ensure transplanted grafts remain healthy.  
            </li>     
          </ul>
        </CardContent>
      </Card>
    ),
    // male_timeline_stage7 : (
    //   <Card className="statCard yourPhotossection">
    //      <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <AccessTimeOutlinedIcon className="cameraIcon" />
    //         <h3 className="photoTitle">Expected timeline with treatment </h3>
    //       </div>
    //       <ul>
    //         <li>
    //           Month 1:  density maintained. 
    //         </li>
    //         <li>
    //           Months 3–6:  No visible changes; subtle improvements in follicle strepossible.
    //         </li>
    //         <li>
    //           Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
    //         </li>
    //       </ul>
    //      </CardContent>
    //   </Card>
    // ),
    // male_lifestyle_stage7 : (
    //   <Card className="statCard yourPhotossection">
    //     <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <h3 className="photoTitle">Lifestyle & daily care support </h3>
    //       </div>
    //       <Typography className="description">Even in advanced stages, supporting scalp and donor health is valuable:</Typography>
    //       <ul>
    //         <li>Nutrition: </li>
    //         <ul>
    //           <li>Biotin — egg yolks, almonds, peanuts, sweet potatoes</li>
    //           <li>Zinc — oysters, chickpeas, lentils, cashews</li>
    //           <li>Balanced intake of vitamins A, D, and E to support scalp condition</li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li>Scalp Care:</li>
    //         <ul>
    //           <li> 
    //             Keep the scalp moisturized and healthy to reduce dryness and irritation. 
    //           </li>
    //           <li> 
    //             Gentle massage can maintain circulation and support post-surgical recovery if transplantation is attempted. 
    //           </li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li>Avoid: Smoking, poor diet, and harsh scalp products that can compromise donor follicle strength. </li>
    //       </ul>
    //       <ul>
    //         <li>Track Progress: Even at Stage 7, continued use of the in-app tracker ensures that scalp condition and any treatment outcomes (transplant, SMP, or systems) are monitored visually. </li>
    //       </ul>
    //     </CardContent>
    //   </Card>
    // ),
    male_legal_stage7 : (
      <Card className="statCard yourPhotossection legalSection stage1">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 
            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Hair loss in women often starts with the parting line, but in your case the central parting appears normal in width, with no visible widening. Hair density across the midline is uniform and full. The scalp is not visible through the hair under the lighting you have used.
          </Typography>
          <Typography className="description mt-10px">
            Individual hair shafts show normal thickness with no signs of miniaturization.  
          </Typography>
          <Typography className="description mt-10px">
            The frontal hairline is intact, with consistent density behind it. The vertex region displays normal coverage without diffuse thinning. Parietal and temporal areas maintain even, symmetrical density.  
          </Typography>
          <Typography className="description mt-10px">
            The spacing between follicles appears regular and compact. The overall hair volume is normal, with no reduction in fullness.  
          </Typography>
          <Typography className="description mt-10px">
            The scalp skin appears healthy, without redness, scaling, or irregularities. Hair distribution remains balanced across all regions of the scalp. There is no visible contrast between the central part and surrounding zones.   
          </Typography>
          <Typography className="description mt-10px">
            The pattern displayed by your pictures corresponds to normal female hair density without early thinning.   
          </Typography>
          {/* <Typography className="description bold mt-10px">
            Conclusion: your photos show a normal hair without visible signs of significant loss.  A free consultation with one of our telemedicine doctors will give you a medical confirmation, if necessary. Click here if you want such a consultation.
          </Typography> */}
        </CardContent>
      </Card>
    ),
    female_why_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            Losing up to 100 hairs per day is normal and should not be a cause for alarm. However, in women with a genetic predisposition, the balance of hormones and follicle sensitivity can gradually change.  
          </Typography>
          <ul>
            <li>
              If close relatives experienced thinning, your risk may be higher. 
            </li>
            <li>
              Oestrogen normally protects the follicles by prolonging the growth phase of the cycle and helping to maintain density. 
            </li>
            <li>
              After menopause, declining oestrogen levels reduce this protection, and follicles become more vulnerable. 
            </li>
            <li>
              Some of the androgens your body produces get converted into dihydrotestosterone (DHT).  
            </li>
            <li>
              In sensitive follicles, DHT binds to receptors and triggers miniaturisation: hairs grow back finer, the active growth phase shortens, and resting phases lengthen. 
            </li>
            <li>
              This process can progress into visible thinning — most often along the central parting and crown, which defines the Sinclair pattern of female hair loss. 
            </li>
          </ul>
          <Typography className="description">
            At stage 1, your coverage is still good. But understanding these mechanisms explains why early vigilance or preventive treatment is often recommended, especially if there is family history. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage0 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>Preventive prescription care may be recommended to protect follicles before visible thinning begins. </li>
          <li>Monitoring is also an option — if you prefer to wait, we recommend repeating the test in 6 months. </li>
          <li>
            A doctor’s evaluation can help you decide if preventive therapy is right for you.
          </li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    female_timeline_stage0 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with preventive care  </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Shedding may stabilise with application of a preventive lotion. 
            </li>
            <li>
              Month 3–6: Subtle thickening possible. 
            </li>
            <li>
              Month 6+: Maintenance of density and delayed onset of thinning. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <Typography className="description">
            Hair health is also highly dependent on the way you eat and take care of your scalp. 
          </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">
              A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required.  There are vitamins and micronutrients that are essential:  
            </Typography>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes </li>
              <li>Zinc —  which is found in chickpeas, cashews, oysters, lentils </li>
              <li>Iron – also present in lentils and chickpeas, as well as shellfish and meat.</li>
              <li>Vitamin D and A — are essential for follicle metabolism present in oily fish, dairy and eggs </li>
              <li>Also include fruits, vegetables, and protein-rich foods to maintain overall balance. </li>
            </ul>
          </ul>
          <ul>
            <li>Scalp care </li>
            <ul>
              <li>Use sulphate-free shampoos. Rosemary or lavender extracts may provide mild anti-DHT support.</li>
              <li>
                Massage the scalp gently with a silicone massager to improve blood circulation. 
              </li>
              <li>Avoid harsh dyes, frequent bleaching, and heat styling.</li>
            </ul>
          </ul>
          <ul>
            <li>Wellness</li>
            <ul>
              <li>Prioritise sufficient sleep and stress management (yoga, meditation, deep breathing). </li>
              <li>Avoid smoking, which reduces blood flow and accelerates hair loss. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage0 : (
      <Card className="statCard yourPhotossection legalSection stage1">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 
            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            The scalp shows early, mild thinning concentrated along the central parting. The midline part appears wider than normal but remains clearly defined. 
          </Typography>
          <Typography className="description mt-10px">
            Hair density on either side of the part is reduced but still uniform and individual hairs appear slightly finer than in unaffected areas.
          </Typography>
          <Typography className="description mt-10px">
            The frontal hairline remains intact, with no visible recession. Surrounding areas, including the temples, maintain normal density. The vertex region shows subtle spacing between hair shafts. 
          </Typography>
          <Typography className="description mt-10px">
            There is no patchiness; the thinning is diffuse and symmetrical. The overall hair volume appears slightly reduced but would have to be compared with earlier photos to confirm this impression.  
          </Typography>
          <Typography className="description mt-10px">
            The scalp skin looks healthy, without redness or scaling. Follicular openings remain visible and evenly distributed. 
          </Typography>
          <Typography className="description bold mt-10px">
           Conclusion: Your photos show hair thinning that may represent the early stages of alopecia. Only a medical consultation with one of our telemedicine doctors will give you a proper diagnosis and a prescription for the most appropriate treatment.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            At stage 2, the first visible signs of follicle miniaturisation appear. 
          </Typography>
          <ul>
            <li>
              In addition to shedding, the regrown hairs are finer and shorter, leading to gradual loss of volume. 
            </li>
            <li>
              The central parting begins to widen as miniaturised hairs provide less coverage. 
            </li>
            <li>
              After menopause, levels of oestrogen and progestogen decline, while androgens exert a stronger influence. 
            </li>
            <li>
              Some of these androgens are converted into dihydrotestosterone (DHT), which binds to follicle receptors and triggers miniaturisation. 
            </li>
            <li>
              Sensitive follicles then produce progressively thinner hair, and coverage decreases.
            </li>
          </ul>
          <Typography className="description">
            This stage marks the shift from invisible shedding to visible thinning, making it a crucial moment to begin preventive treatment.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage1 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>A doctor may find that you need a prescription of anti-androgen therapy that can block follicle sensitivity to DHT and preserve thickness.</li>
          <li>Such topical treatments may stimulate regrowth of miniaturised hairs.</li>
          <li>Regular monitoring with repeat tests every 2 months will help track stability and guide adjustments.</li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    female_timeline_stage1 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with preventive care  </h3>
          </div>
          <ul>
            <li>
              Month 1-2: Stabilisation of shedding 
            </li>
            <li>
              Months 3-6: New regrowth begins to appear  
            </li>
            <li>
              Months 6-12: Visible thickening, improved volume, and reduction in scalp visibility
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <Typography className="description mt-10px">
            Hair health is also highly dependent on the way you eat and take care of your scalp.
          </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">
              A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required.  There are vitamins and micronutrients that are essential:  
            </Typography>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes </li>
              <li> Zinc —  which is found in chickpeas, cashews, oysters, lentils </li>
              <li>
                Iron – also present in lentils and chickpeas, as well as shellfish and meat.
              </li>
              <li>
                Vitamin D and A — are essential for follicle metabolism present in oily fish, dairy and eggs
              </li>
              <li>
                Also include fruits, vegetables, and protein-rich foods to maintain overall balance.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoos. Rosemary or lavender extracts may provide mild anti-DHT support.</li>
              <li>
                Massage the scalp gently with a silicone massager to improve blood circulation. 
              </li>
              <li>Avoid harsh dyes, frequent bleaching, and heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Prioritise sufficient sleep and stress management (yoga, meditation, deep breathing). </li>
              <li>
                Avoid smoking, which reduces blood flow and accelerates hair loss.  
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage1 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 
            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary. No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            The central parting is noticeably widened, extending from the frontal region toward the midscalp. Hair density along the midline is moderately reduced, with clear visibility of the underlying scalp. 
          </Typography>
          <Typography className="description mt-10px">
            The thinning forms a triangular or elongated zone centred on the parting. The contrast between the central thinning and the denser lateral zones is clearly visible. The thinning pattern remains symmetrical, without patchy loss. 
          </Typography>
          <Typography className="description mt-10px">
            The frontal hairline remains preserved, with no recession at the temples. The vertex region begins to show mild diffuse thinning, though less pronounced than the midline. The surrounding parietal areas maintain relatively normal density.
          </Typography>
          <Typography className="description mt-10px">
            Individual hair shafts appear finer and shorter in the affected area. The spacing between follicles is increased, but follicular openings remain visible. The overall hair volume is reduced. The scalp skin appears healthy, without erythema, scaling, or scarring.
          </Typography>
          <Typography className="description bold mt-10px">
            Conclusion: Your photos show hair thinning that may represent the advanced stages of alopecia. Only a medical consultation with one of our telemedicine doctors will give you a proper diagnosis and a prescription for the most appropriate treatment. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            At Stage 3, the process of follicle miniaturisation that has started at menopause becomes visible.
          </Typography>
          <ul>
            <li>
              Shedding has resulted in a scalp that shows clearly through the central parting, and thinning is noticeable in normal lighting. 
            </li>
            <li>
              Miniaturised hairs, typical of alopecia, are thinner and shorter, which reduces their ability to provide volume and coverage. 
            </li>
            <li>
              After menopause, the decline in oestrogen and progestogen removes much of the natural protection that previously helped maintain density. 
            </li>
            <li>
              This shift allows androgens, particularly dihydrotestosterone (DHT), to play a more prominent role, and DHT causes the miniaturisation process as well as the loss of ability of follicles to generate new quality hair.   
            </li>
            <li>
              The hair cycle becomes imbalanced: the growth phase shortens, while the resting phase lengthens, resulting in continuous shedding without full replacement.  
            </li>
            <li>
              This is a frequent and the biochemical process leading to the effect of DHT to the follicles has been thoroughly studied.  
            </li>
          </ul>
          <Typography className="description">
            At Stage 3, this process is still highly manageable with treatment — but if ignored, progression to more advanced stages becomes likely. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage2 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>A doctor may find that the prescription of topical anti-androgen therapies  can significantly slow or halt progression. </li>
          <li>Combination approaches (medical + supportive care) give the best chance of visible thickening. </li>
          <li>Follow-up testing every 2 months is recommended to track changes and adjust treatment. </li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    female_timeline_stage2 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1-2: Stabilisation of shedding
            </li>
            <li>
              Months 3-6: New regrowth begins to appear 
            </li>
            <li>
              Months 6-12: Visible thickening, improved volume, and reduction in scalp visibility 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <Typography className="description">
            Hair health is also highly dependent on the way you eat and take care of your scalp. 
          </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">
              A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required.  There are vitamins and micronutrients that are essential:   
            </Typography>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes </li>
              <li>Zinc —  which is found in chickpeas, cashews, oysters, lentils </li>
              <li>
                Iron – also present in lentils and chickpeas, as well as shellfish and meat.   
              </li>
              <li>
                Vitamin D and A — are essential for follicle metabolism present in oily fish, dairy and eggs 
              </li>
              <li>
                Also include fruits, vegetables, and protein-rich foods to maintain overall balance.    
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoos; natural options with rosemary or lavender may support scalp health. </li>
              <li>Perform gentle scalp massage daily to stimulate circulation (unless using prescription topicals). </li>
              <li>Avoid harsh chemical treatments and high-heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>
                Ensure adequate sleep and manage stress through yoga, meditation, or relaxation.
              </li>
              <li>
                Do not smoke, as it reduces scalp blood flow and accelerates miniaturisation.  
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage2 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            The central parting is markedly widened, extending from the frontal region through the midscalp. The thinning zone forms a broad, elongated area with clear scalp visibility. Hair density along the midline is substantially reduced, with sparse coverage. Individual hair shafts in the affected region appear significantly miniaturized. 
          </Typography>
          <Typography className="description mt-10px">
            The frontal hairline remains structurally preserved, though the density behind it is diminished. The contrast between the central thinning and the denser lateral zones is pronounced. The scalp shows continuous exposure along the central strip. The vertex displays moderate diffuse thinning, contributing to reduced overall volume. 
          </Typography>
          <Typography className="description mt-10px">
            Parietal areas retain relatively normal density, highlighting the central loss. 
          </Typography>
          <Typography className="description mt-10px">
            Follicular spacing is clearly increased, though follicular openings remain visible. The hair appears noticeably flatter and less voluminous than normally.  
          </Typography>
          <Typography className="description mt-10px">
            The thinning pattern remains symmetrical, without discrete patches. The scalp skin appears healthy, with no signs of inflammation or scarring.  
          </Typography>
          <Typography className="description bold mt-10px">
            Conclusion: Your photos show severe hair thinning that may represent the most advanced stages of alopecia. Only a medical consultation with one of our telemedicine doctors will give you a proper diagnosis and a prescription for the most appropriate treatment.   
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            By stage 4, the process of follicle miniaturisation has advanced significantly.  
          </Typography>
          <ul>
            <li>After menopause, the oestrogens that protected the hair follicles disappear and they become sensitive to androgens, and particularly dihydro-testosterone (DHT). Not all women lose hair after menopause; only those whose follicles are genetically sensitive to DHT, which shortens the life of follicles, shrinks them and blocks hair growth.</li>
            <li>
              Miniaturised hairs dominate, producing strands that are progressively finer, weaker, and less pigmented. 
            </li>
            <li>
              The growth cycle becomes more disrupted: fewer hairs enter the anagen (growth) phase, while more shift into telogen (resting), which accelerates visible loss.   
            </li>
          </ul>
          <Typography className="description">
            At this stage, the loss of volume is substantial, and the scalp is conspicuous in most lighting conditions.  An appropriate intervention is essential to preserve the remaining density, stop further progression and regrow healthy hair. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage3 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>A medical doctor can prescribe an effective anti-DHT treatment to preserve remaining active follicles and regrow hair from those that can be revived.</li>
          <li>Anti-androgen therapies can block DHT activity and extend growth phases, but can only be recommended by a medical doctor after careful evaluation of your condition. </li>
          <li>Combination therapy — prescription + lifestyle measures — offers the best chance of visible recovery. </li>
          <li>Ongoing monitoring with repeat tests every 2 months is essential to track treatment effectiveness. </li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    // female_timeline_stage3 : (
    //   <Card className="statCard yourPhotossection">
    //      <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <AccessTimeOutlinedIcon className="cameraIcon" />
    //         <h3 className="photoTitle">Expected timeline with treatment </h3>
    //       </div>
    //       <ul>
    //         <li>
    //           Month 1–2: Stabilisation of shedding 
    //         </li>
    //         <li>
    //           Month 3–6: Thickening of miniaturised hairs 
    //         </li>
    //         <li>
    //           Month 6–12: Visible improvement in scalp coverage and parting density 
    //         </li>
    //       </ul>
    //      </CardContent>
    //   </Card>
    // ),
    female_lifestyle_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <Typography className="description">
            Hair health is also highly dependent on the way you eat and take care of your scalp. 
          </Typography>
          <ul>
            <li>Nutrition</li>
            <ul>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes </li>
              <li>Zinc —  which is found in chickpeas, cashews, oysters, lentils </li>
              <li>
                Iron – also present in lentils and chickpeas, as well as shellfish and meat. 
              </li>
              <li>
                Vitamin D and A — are essential for follicle metabolism present in oily fish, dairy and eggs 
              </li>
              <li>
                Also include fruits, vegetables, and protein-rich foods to maintain overall balance.  
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>
                Use sulphate-free shampoos; natural options with rosemary or lavender may support scalp health. 
              </li>
              <li>Perform gentle scalp massage daily to stimulate circulation (unless using prescription topicals). </li>
              <li>Avoid harsh chemical treatments and high-heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Ensure adequate sleep and manage stress through yoga, meditation, or relaxation.  </li>
              <li>
                Do not smoke, as it reduces scalp blood flow and accelerates miniaturisation. 
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage3 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            The central thinning has progressed to a broad, continuous band extending from the frontal region through the midscalp. The scalp is clearly and consistently visible across the entire midline zone.
          </Typography>
          <Typography className="description mt-10px">
            Hair density in the affected area is markedly reduced, with only sparse, miniaturized hairs remaining. The thinning zone spans several centimetres in width, forming a diffuse, elongated pattern. 
          </Typography>
          <Typography className="description mt-10px">
            The frontal hairline remains structurally present, but density immediately behind it is severely diminished. The contrast between the central thinning and the lateral scalp is pronounced, though lateral density seems to also begin to decline. The vertex region exhibits significant diffuse thinning, contributing to an overall impression of reduced coverage. Parietal areas retain moderate density but no longer compensate visually for the central loss.
          </Typography>
          <Typography className="description mt-10px">
            Follicular openings remain visible, indicating nonscarring hair loss. The remaining hairs in the thinning zone are fine, short, and widely spaced. The overall hair volume is substantially reduced, even when styled to maximize coverage. 
          </Typography>
          <Typography className="description mt-10px">
            The thinning pattern remains overall symmetrical, without discrete patches or irregular borders. The scalp skin appears healthy, without signs of inflammation, scaling, or scarring.
          </Typography>
          <Typography className="description bold mt-10px">
            Conclusion: Your photos show very severe hair thinning that may represent the most advanced stage of alopecia. Only a medical consultation with one of our telemedicine doctors will give you a proper diagnosis and a prescription for the most appropriate treatment. Even at this stage, taking action matters. A consultation can help you understand what is possible, whether it’s stabilizing the sides and back, exploring cosmetic or surgical options, or simply receiving professional guidance on how to manage the situation with confidence.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            At Stage 5, the process of miniaturisation has reached an advanced level, and the impact on coverage is significant. 
          </Typography>
          <ul>
            <li>
              After menopause, the oestrogens that protected the hair follicles disappear and they become sensitive to androgens, and particularly dihydro-testosterone (DHT). Not all women lose hair after menopause; only those whose follicles are genetically sensitive to DHT, which shortens the life of follicles, shrinks them and blocks hair growth.
            </li>
            <li>
              Miniaturised hairs dominate, producing strands that are progressively finer, weaker, and less pigmented.  
            </li>
            <li>
              The growth cycle becomes more disrupted: fewer hairs enter the anagen (growth) phase, while more shift into telogen (resting), which accelerates visible loss.  
            </li>
          </ul>
          <Typography className="description">
            This explains why Stage 5 represents a severe form of female pattern hair loss. The scalp is highly visible in nearly all lighting conditions, and spontaneous recovery is unlikely. A medical intervention is essential at this point to maintain the remaining density and prevent further irreversible progression.   
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage4 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li> A doctor may prescribe a medical anti-DHT treatment to you.  Such prescription therapies can reduce androgen sensitivity and reactivate dormant follicles.</li>
          <li>
            If your goal is to restore coverage in visibly areas, a hair transplant is currently the most effective solution. There are two primary techniques: 
            <ul>
              <li>FUT (Follicular Unit Transplantation): A strip of scalp is removed from a donor area, and individual follicular units are transplanted. </li>
              <li>FUE (Follicular Unit Extraction): Individual follicles are harvested directly from the donor area and implanted into the balding zones. </li>
            </ul>
            Both methods have their own advantages and limitations, and the choice depends on your scalp condition, donor hair availability, and personal preferences. When performed by a skilled and experienced surgeon, success rates typically exceed 90%. The cost of a transplant depends on the number of follicles required, and multiple sessions may be recommended to achieve optimal coverage and natural-looking results.
          </li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    female_timeline_stage4 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1-2: Stabilisation of shedding
            </li>
            <li>
              Months 3-6: Reactivation of weakened follicles, with early regrowth 
            </li>
            <li>
              Months 6-12: Visible thickening and improved scalp coverage, though full restoration may not be possible 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <Typography className="description">
            Hair health is also highly dependent on the way you eat and take care of your scalp. 
          </Typography>
          <ul>
            <li>Nutrition</li>
            <ul>
              <Typography className="description">
                A proper nutrition, rich in proteins (hair is mostly made of one important protein, keratin) is required.  There are vitamins and micronutrients that are essential:   
              </Typography>
              <li>Biotin — present in egg yolks, peanuts, almonds, sweet potatoes </li>
              <li> Zinc —  which is found in chickpeas, cashews, oysters, lentils </li>
              <li>
                Iron – also present in lentils and chickpeas, as well as shellfish and meat. 
              </li>
              <li>
                Vitamin D and A — are essential for follicle metabolism present in oily fish, dairy and eggs 
              </li>
              <li>
                Also include fruits, vegetables, and protein-rich foods to maintain overall balance.  
              </li>
            </ul>
          </ul>
          {/* <ul>
            <li> Scalp Care </li>
            <ul>
              <li>
                Stick to sulphate-free shampoos, ideally with natural supportive ingredients. 
              </li>
              <li>Gentle scalp massage daily can improve circulation, unless contraindicated by topical therapy. </li>
              <li>Avoid frequent bleaching, dyes, or heavy heat styling. </li>
            </ul>
          </ul> */}
          <ul>
            <li> Wellness </li>
            <ul>
              <li>
                Ensure adequate sleep and manage stress through yoga, meditation, or relaxation. 
              </li>
              <li>
                Do not smoke, as it reduces scalp blood flow and accelerates miniaturisation. 
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage4 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 
            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
  })

  const [masterJsonFr] = useState({
    male_photos_description_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Vos photos montrent</h3>
          </div>
          <Typography className="description">
            Vos photos montrent une ligne frontale complète et intacte, sans amincissement visible au niveau des tempes ni du sommet. À ce stade, la densité capillaire est normale et aucun signe de perte n’est visible. 
          </Typography>
          <Typography className="description mt-10px">
            Vous avez probablement passé ce test parce que vous êtes préoccupé par une chute de cheveux plus importante que d’habitude. Il est normal de perdre jusqu’à 100 cheveux par jour, mais une perte plus abondante peut indiquer le début d’une alopécie androgénétique, même si aucune zone dégarnie n’est encore visible. 
          </Typography>
          <Typography className="description mt-10px">
            Commencer une prise en charge préventive dès maintenant peut aider à préserver votre densité naturelle et à retarder toute progression future. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Pourquoi cela arrive </h3>
          </div>
          <Typography className="description">
            Même si le cuir chevelu paraît normal au stade 1, le processus biologique de l’alopécie androgénétique peut déjà avoir commencé sous la surface. 
          </Typography>
          <ul>
            <li>Après la puberté, le taux de testostérone augmente. Environ 10 % de cette testostérone est convertie en DHT (dihydrotestostérone) par deux enzymes : la 5-alpha-réductase de type I et II. </li>
            <li>
              Chez les personnes sensibles, la DHT se fixe sur les récepteurs des follicules pileux et provoque leur rétrécissement progressif. 
            </li>
            <li>
              Cela entraîne des cheveux plus fins et plus fragiles, une phase de croissance raccourcie et un plus grand nombre de follicules entrant en phase de repos, ce qui se traduit par une chute accrue et une repousse plus lente.  
            </li>
            <li>
              Avec le temps, certains follicules deviennent inactifs et perdent la capacité de produire de nouveaux cheveux. 
            </li>
            {/* <li>
              If untreated, this process progresses silently until it becomes noticeable Stage orStage 3.
            </li> */}
          </ul>
          {/* <Typography className="description">
            Stage 1 is therefore the   ideal window for prevention, as early interventicaprotectfollicles long before visible thinning occurs. 
          </Typography> */}
        </CardContent>
      </Card>
    ),
    male_what_stage0 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">Ce que vous pouvez faire </h3>
        </div>
        <ul>
          <li>Un traitement préventif peut être recommandé si vous avez des antécédents familiaux de calvitie ou si un amincissement microscopique est détecté.</li>
          <li>Une bonne hygiène de vie et une alimentation équilibrée soutiennent la santé des follicules et peuvent retarder l’apparition de la perte visible. </li>
          <li>Les patients qui commencent un traitement à ce stade maintiennent souvent leur densité naturelle pendant de nombreuses années. </li>
        </ul>
        {/* <Typography className="description mt-10px">
          Next Steps: Access Prescription - Only Treatment
        </Typography> */}
      </>
    ),
    male_timeline_stage0 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Chronologie attendue avec un soin préventif </h3>
          </div>
          <ul>
            <li>
              Mois 1 : densité maintenue.  
            </li>
            <li>
              Mois 3 – 6 : aucun changement visible ; un renforcement subtil des follicules est possible. 
            </li>
            <li>
              Mois 6 – 12 : un suivi régulier permet de détecter et de traiter rapidement tout signe précoce d’évolution. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Conseils de mode de vie et de soins quotidiens  </h3>
          </div>
          <Typography className="description">À ce stade précoce, un soin de soutien suffit souvent à maintenir la vitalité des follicules. Il comprend une alimentation adaptée et des soins appropriés du cuir chevelu. </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">
              Une alimentation riche en protéines – la kératine étant le principal composant du cheveu – et en micronutriments est essentielle : 
            </Typography>
            <ul>
              <li>Biotine : jaune d’œuf, arachides, amandes, patates douces </li>
              <li>Zinc : pois chiches, noix de cajou, huîtres, lentilles </li>
              <li>Fer : lentilles, pois chiches, fruits de mer, viande rouge</li>
              <li>Vitamines D et A : essentielles au métabolisme folliculaire </li>
            </ul>
          </ul>
          <ul>
            <li>Soin du cuir chevelu </li>
            <ul>
              <li> 
                Massez doucement le cuir chevelu avec un masseur en silicone pour stimuler la circulation. 
              </li>
              <li> 
                Évitez les colorations agressives, le séchage à air chaud et les coiffures trop serrées. 
              </li>
              <li> 
                Utilisez un shampooing doux à base d’ingrédients naturels ayant une légère activité anti-DHT (bhringraj, amla, palmier nain, romarin).  
              </li>
            </ul>
          </ul>
          <ul>
            <li>Mode de vie </li>
            <ul>
              <li> 
                Évitez de fumer ; le tabac accélère l’amincissement. 
              </li>
              <li> 
                Dormez suffisamment et gérez le stress.
              </li>
              <li> 
                Suivez vos progrès : téléversez des photos de votre cuir chevelu tous les 6 à 12 mois pour repérer les éventuelles variations de densité.   
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage0 : (
      <Card className="statCard yourPhotossection legalSection stage1">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Avisos médicos y legales</h3>
          </div>
          <ul>
            <li>
              Solo un médico autorizado puede realizar un diagnóstico y prescribir un tratamiento. 
            </li>
            <li>
              Las fórmulas mencionadas son preparaciones magistrales, elaboradas por farmacias autorizadas. 
            </li>
            <li>
              Tus imágenes son anónimas y tu rostro se mantiene oculto; solo se almacenan si das tu consentimiento explícito para fines de investigación.
            </li>
            <li>
              Los resultados pueden variar según los factores genéticos y la constancia en el tratamiento.  
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Vos photos montrent</h3>
          </div>
          <Typography className="description">
            Vos photos montrent un léger recul de la ligne frontale au niveau des tempes, tandis que la couronne et le sommet conservent une bonne densité.  
          </Typography>
          <Typography className="description mt-10px">
            Ce stade correspond au Norwood 2, où les premiers signes visibles de recul apparaissent. Vous avez probablement remarqué que votre front semble un peu plus dégagé ou que certaines coiffures mettent davantage en évidence la zone des tempes. 
          </Typography>
          <Typography className="description mt-10px">
            À ce stade, la perte reste minime et peut être inversée si elle est prise en charge rapidement. Les hommes qui commencent un traitement précoce stabilisent souvent la chute et conservent leur densité naturelle pendant de nombreuses années. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Pourquoi cela arrive</h3>
          </div>
          <Typography className="description">
            Au stade 2, les premiers signes visibles de miniaturisation des follicules apparaissent. 
          </Typography>
          <ul>
            <li>
              Après la puberté, le taux de testostérone augmente. Environ 10 % de cette testostérone est convertie en DHT (dihydrotestostérone) par les enzymes 5-alpha-réductase de type I et II. 
            </li>
            <li>
              La DHT se fixe sur les récepteurs des follicules situés au niveau des tempes et provoque leur rétrécissement progressif. 
            </li>
            <li>
              Cela entraîne des cheveux plus fins et plus courts, ce qui donne une impression de recul de la ligne frontale.  
            </li>
            <li>
              La phase de croissance (anagène) se raccourcit, tandis que la phase de repos (télogène) s’allonge, ce qui peut rendre la chute plus visible au fil du temps.   
            </li>
          </ul>
          <Typography className="description">
            Le stade 2 est donc le moment idéal pour agir : une intervention précoce peut bloquer la miniaturisation avant qu’elle ne progresse. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage1 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">Ce que vous pouvez faire </h3>
        </div>
        <ul>
          <li>Un médecin peut prescrire un traitement anti-DHT pour protéger les follicules sensibles et préserver la densité existante. </li>
          <li>Des soins topiques ou des peptides spécifiques peuvent être associés afin de renforcer les cheveux et améliorer la vitalité du cuir chevelu. </li>
          <li>Un mode de vie sain (sommeil suffisant, gestion du stress, alimentation équilibrée, absence de tabac) favorise des résultats durables. </li>
        </ul>
        <Typography className="description mt-10px">
          Accéder au traitement sur prescription médicale 
        </Typography>
      </>
    ),
    male_timeline_stage1 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Chronologie attendue avec le traitement </h3>
          </div>
          <ul>
            <li>
              Mois 1 – 2 : stabilisation de la perte de cheveux.  
            </li>
            <li>
              Mois 3 – 6 : les follicules des tempes commencent à produire des cheveux plus épais et plus forts. 
            </li>
            <li>
              Mois 6 – 12 : restauration visible de la ligne frontale et amélioration de la densité.  
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Conseils de mode de vie et de soins quotidiens  </h3>
          </div>
          <Typography className="description">À ce stade précoce, des soins réguliers suffisent souvent à maintenir la vitalité des follicules. Ils incluent une nutrition adaptée et des soins appropriés du cuir chevelu. </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">Une alimentation riche en protéines et en micronutriments favorise la croissance capillaire:</Typography> 
            <ul>
              <li>Biotine : jaune d’œuf, arachides, amandes, patates douces </li>
              <li>Zinc : pois chiches, noix de cajou, huîtres, lentilles </li>
              <li>Fer : lentilles, pois chiches, fruits de mer, viande rouge </li>
              <li>Vitamines D et A : essentielles au métabolisme folliculaire </li>
              <li>Consommez également des fruits et légumes variés pour leurs vitamines et antioxydants. </li>
            </ul>
          </ul>
          <ul>
            <li>Soin du cuir chevelu </li>
            <ul>
              <li> Massez doucement le cuir chevelu chaque jour pour stimuler la micro-circulation. </li>
              <li> Utilisez un shampooing doux sans sulfates et à base d’ingrédients naturels (palmier nain, romarin, bhringraj, amla). </li>
              <li> Évitez les colorations agressives et le séchage à air chaud. </li>
            </ul>
          </ul>
          <ul>
            <li>Mode de vie </li>
            <ul>
              <li> Évitez de fumer, car cela accélère l’amincissement capillaire. </li>
              <li> Dormez suffisamment et gérez le stress.  </li>
              <li> Suivez vos progrès : prenez des photos du cuir chevelu tous les 3 mois pour détecter les changements précoces.  </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage1 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Vos photos montrent </h3>
          </div>
          <Typography className="description">
            Vos photos montrent un recul plus marqué de la ligne frontale, particulièrement au niveau des tempes. La densité est réduite sur la partie avant du cuir chevelu, tandis que la couronne reste encore bien couverte. 
          </Typography>
          <Typography className="description mt-10px">
            Ce stade correspond au Norwood 3, où les signes de calvitie deviennent visibles sous une lumière normale. Vous avez probablement remarqué une perte de volume ou plus de difficulté à coiffer vos cheveux comme auparavant. 
          </Typography>
          <Typography className="description mt-10px">
            Les hommes qui commencent un traitement à ce stade parviennent souvent à stabiliser la chute et à retrouver une densité visible en quelques mois. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Pourquoi cela arrive </h3>
          </div>
          <Typography className="description">
            Au stade 3, le processus de miniaturisation des follicules est bien installé 
          </Typography>
          <ul>
            <li>Après la puberté, le taux de testostérone augmente. Environ 10 % de cette testostérone est convertie en DHT (dihydrotestostérone) par les enzymes 5-alpha-réductase de type I et II. </li>
            <li>
              Chez les personnes génétiquement sensibles, la DHT se fixe sur les récepteurs des follicules pileux, provoquant leur rétrécissement progressif. 
            </li>
            <li>
              Cela entraîne des cheveux plus fins et plus fragiles, une phase de croissance (anagène) raccourcie et un plus grand nombre de follicules entrant en phase de repos (télogène).
            </li>
            <li>
              Avec le temps, certains follicules deviennent inactifs et perdent la capacité de produire de nouveaux cheveux.  
            </li>
          </ul>
          {/* <Typography className="description">
            This explains why Stage 3 is such an important intervention point: the temples are highly sensitive to DHT, and visible hairline recession is a clear sign that miniaturization is well underway. Acting early can still preserve most of the follicles, restore visible thickness, and prevent progression into more advanced stages.
          </Typography> */}
        </CardContent>
      </Card>
    ),
    male_what_stage2 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">Ce que vous pouvez faire </h3>
        </div>
        {/* <Typography className="description">
          Un médecin peut prescrire un traitement anti-DHT pour bloquer l’action hormonale sur les follicules sensibles et préserver la densité. 
        </Typography> */}
        <ul>
          <li>Un médecin peut prescrire un traitement anti-DHT pour bloquer l’action hormonale sur les follicules sensibles et préserver la densité.  </li>
          <li>Des soins topiques ou des peptides spécifiques peuvent être associés pour stimuler la repousse et renforcer la fibre capillaire. </li>
          <li>Un suivi régulier, avec photos tous les 2 à 3 mois, permet d’évaluer la stabilité et d’ajuster le protocole si nécessaire. </li>
        </ul>
        <Typography className="description mt-10px">
          Accéder au traitement sur prescription médicale 
        </Typography>
        {/* <Typography className="description">
          A licensed doctor will review your case, confirm the stage, and prescribe the most effective treatment plan.
        </Typography> */}
      </>
    ),
    male_timeline_stage2 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Chronologie attendue avec le traitement  </h3>
          </div>
          <ul>
            <li>
              Mois 1 – 2 : stabilisation de la chute. 
            </li>
            <li>
              Mois 3 – 6 : la repousse devient visible, notamment au niveau des tempes. 
            </li>
            <li>
              Mois 6 – 12 : épaississement progressif de la ligne frontale et amélioration de la densité. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Conseils de mode de vie et de soins quotidiens   </h3>
          </div>
          <Typography className="description">À ce stade, un traitement médical est essentiel, mais des soins de soutien permettent d’optimiser les résultats. Ils incluent une nutrition adaptée et des soins réguliers du cuir chevelu. </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">Une alimentation riche en protéines et en nutriments essentiels soutient la santé des cheveux:</Typography>
            <ul>
              <li>Biotine : jaune d’œuf, arachides, amandes, patates douces </li>
              <li>Zinc : pois chiches, noix de cajou, huîtres, lentilles </li>
              <li>Fer : lentilles, pois chiches, fruits de mer, viande rouge </li>
              <li>Vitamines D et A : essentielles au métabolisme folliculaire </li>
            </ul>
          </ul>
          <ul>
            <li>Soin du cuir chevelu</li>
            <ul>
              <li>Massez le cuir chevelu chaque jour pour stimuler la micro-circulation. </li>
              <li>Utilisez un shampooing doux sans sulfates à base d’ingrédients naturels (palmier nain, romarin, bhringraj, amla). </li>
              <li>Évitez les colorations agressives et le séchage à air chaud. </li>
            </ul>
          </ul>
          <ul>
            <li>Mode de vie </li>
            <ul>
              <li>Évitez le tabac ; il accélère l’amincissement capillaire. </li>
              <li>Assurez-vous de dormir suffisamment et de gérer le stress. </li>
              <li>Suivez vos progrès en photographiant régulièrement votre cuir chevelu pour détecter les changements précoces. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage2 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Vos photos montrent </h3>
          </div>
          <Typography className="description">
            Vos photos montrent un élargissement marqué de la raie centrale, avec le cuir chevelu clairement visible. Les zones frontales et du sommet montrent une densité réduite, tandis que les régions latérales et occipitales (arrière de la tête) restent bien couvertes. 
          </Typography>
          <Typography className="description mt-10px">
            Ce stade correspond au Norwood 4, où la perte de cheveux devient visible même dans les situations courantes, souvent source d’inconfort et de changements de coiffure pour dissimuler les zones dégarnies. 
          </Typography>
          <Typography className="description mt-10px">
            Les hommes qui commencent un traitement à ce stade stabilisent souvent la progression et observent une amélioration visible de la densité en 6 à 12 mois. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Pourquoi cela arrive </h3>
          </div>
          <Typography className="description">
            La progression de la perte de cheveux est principalement causée par une sensibilité génétique à la DHT (dihydrotestostérone). 
          </Typography>
          <ul>
            <li>
              Après la puberté, le taux de testostérone augmente. Environ 10 % de cette testostérone est convertie en DHT par les enzymes 5-alpha-réductase de type I et II. </li>
            <li>
              La DHT se fixe aux récepteurs des follicules pileux, entraînant leur rétrécissement, leur affaiblissement et, avec le temps, leur inactivité. 
            </li>
            <li>
              Les tempes et le sommet sont particulièrement sensibles à la DHT, ce qui explique pourquoi ces zones sont souvent les premières à être touchées par la perte de cheveux. 
            </li>
            {/* <li>
              The growth phase (anagen) of the hair cycle shortens, while the resting phase (telogen) lengthens. As a result, shedding increases, regrowth slows, and the density of the scalp visibly decreases.
            </li>
            <li>
              At Stage 4, a significant number of follicles are already compromised, and some may have become inactive, unable to produce hair altogether. 
            </li> */}
          </ul>
          {/* <Typography className="description">
            This is why Stage 4 requires urgent medical treatment — it is the last stage where medical therapy alone can still produce meaningful regrowth for many patients.  
          </Typography> */}
        </CardContent>
      </Card>
    ),
    male_what_stage3 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">Ce que vous pouvez faire </h3>
        </div>
        <ul>
          <li>Un médecin peut prescrire un traitement anti-DHT pour bloquer l’action hormonale sur les follicules sensibles et préserver la densité. </li>
          <li>Des soins topiques ou des peptides spécifiques peuvent être associés pour stimuler la repousse et renforcer la fibre capillaire. </li>
          <li>Un suivi régulier, avec photos tous les 2 à 3 mois, permet d’évaluer la stabilité et d’ajuster le protocole si nécessaire. </li>
          {/* <li>Without medical treatment, progression to Stage 5 and beyond is highly likely. </li> */}
        </ul>
        <Typography className="description mt-10px">
          Accéder au traitement sur prescription médicale 
        </Typography>
      </>
    ),
    male_timeline_stage3 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Chronologie attendue avec le traitement </h3>
          </div>
          <ul>
            <li>
              Mois 1 – 2 : la chute se stabilise progressivement. 
            </li>
            <li>
              Mois 3 – 6 : les cheveux deviennent plus forts et plus denses.  
            </li>
            <li>
              Mois 6 – 12 : amélioration visible de la couverture et de la texture. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Conseils de mode de vie et de soins quotidiens  </h3>
          </div>
          <Typography className="description"> À ce stade, un traitement médical est essentiel, mais des soins complémentaires aident à maximiser les résultats. </Typography>
          <ul>
            <li>Nutrition</li>
            <Typography className="description">Une alimentation riche en protéines et en nutriments essentiels soutient la santé des cheveux :</Typography>
            <ul>
              <li>Biotine : jaune d’œuf, arachides, amandes, patates douces </li>
              <li> Zinc : pois chiches, noix de cajou, huîtres, lentilles </li>
              <li>Fer : lentilles, pois chiches, fruits de mer, viande rouge </li>
              <li>Vitamines D et A : essentielles au métabolisme folliculaire </li>
            </ul>
          </ul>
          <ul>
            <li>Soin du cuir chevelu </li>
            <ul>
              <li>Massez le cuir chevelu chaque jour pour stimuler la micro-circulation.</li>
              <li>Utilisez un shampooing doux sans sulfates à base d’ingrédients naturels (palmier nain, romarin, bhringraj, amla). </li>
              <li>Évitez les colorations agressives et le séchage à air chaud. </li>
            </ul>
          </ul>
          <ul>
            <li>Mode de vie </li>
            <ul>
              <li>Évitez de fumer, car cela accélère l’amincissement. </li>
              <li>Dormez suffisamment et gérez le stress. </li>
              <li>Prenez des photos de votre cuir chevelu tous les 3 à 6 mois pour suivre la progression. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage3 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Vos photos montrent </h3>
          </div>
          <Typography className="description">
            Vos photos montrent une perte de cheveux avancée, avec un amincissement visible à la fois sur le front et le sommet du cuir chevelu. Les zones frontales et la couronne commencent à se rejoindre, tandis que les côtés et l’arrière conservent encore une densité normale. 
          </Typography>
          <Typography className="description mt-10px">
            Ce stade correspond au Norwood 5, où la perte devient difficile à masquer sans intervention. Vous avez probablement remarqué que le cuir chevelu est plus visible sous la lumière et que le volume général est nettement réduit. 
          </Typography>
          <Typography className="description mt-10px">
            Les hommes qui entreprennent un traitement à ce stade peuvent encore préserver les follicules actifs et améliorer visiblement la couverture. 
          </Typography>
          {/* <Typography className="description mt-10px">
            Immediate treatment is critical. With proper care, responsive follicles can be preserved, though some areas may require transplant for coverage.
          </Typography> */}
        </CardContent>
      </Card>
    ),
    male_why_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Pourquoi cela arrive </h3>
          </div>
          <Typography className="description">
            La progression de la perte de cheveux est principalement causée par une sensibilité génétique à la DHT (dihydrotestostérone). 
          </Typography>
          <ul>
            <li>
              Après la puberté, le taux de testostérone augmente. Environ 10 % de cette testostérone est convertie en DHT par les enzymes 5-alpha-réductase de type I et II. </li>
            <li>
              La DHT se fixe aux récepteurs des follicules pileux, entraînant leur rétrécissement, leur affaiblissement et, avec le temps, leur inactivité. 
            </li>
            <li>
              Les tempes et le sommet sont particulièrement sensibles à la DHT, ce qui explique pourquoi ces zones sont souvent les premières à montrer des signes de perte de cheveux. 
            </li>
          </ul>
          {/* <Typography className="description">
            This is why Stage 5 is considered advanced androgenetic alopecia: while some follicles can still respond to medical therapy, many are already inactive and may only be restored through surgical options such as transplantation.  
          </Typography> */}
        </CardContent>
      </Card>
    ),
    male_what_stage4 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">Ce que vous pouvez faire </h3>
        </div>
        <ul>
          <li>Un médecin peut prescrire un traitement médical ciblé pour réduire l’action de la DHT et protéger les follicules encore actifs. </li>
          <li>Des soins topiques et des traitements complémentaires peuvent soutenir la repousse et renforcer les cheveux existants. </li>
          <li>À ce stade, une consultation spécialisée est importante pour évaluer la possibilité d’une greffe capillaire ou d’autres solutions adaptées.  </li>
        </ul>
        <Typography className="description mt-10px">
          Accéder au traitement sur prescription médicale 
        </Typography>
      </>
    ),
    male_timeline_stage4 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Chronologie attendue avec le traitement </h3>
          </div>
          <ul>
            <li>
              Mois 1 – 2 : stabilisation de la chute.  
            </li>
            <li>
              Mois 3 – 6 : les cheveux deviennent plus épais et la couverture commence à s’améliorer. 
            </li>
            <li>
              Mois 6 – 12 : densité renforcée, réduction de la visibilité du cuir chevelu.  
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Conseils de mode de vie et de soins quotidiens  </h3>
          </div>
          {/* <Typography className="description"> At this stage, supportive care is especially important to protect and strengthen remaining follicles: </Typography> */}
          <ul>
            <li>Nutrition</li>
            <Typography className="description"> Une alimentation équilibrée et riche en nutriments est essentielle pour soutenir la croissance des cheveux:</Typography>
            <ul>
              <li>Biotine : jaune d’œuf, arachides, amandes, patates douces </li>
              <li>Zinc : pois chiches, noix de cajou, huîtres, lentilles</li>
              <li>Fer : lentilles, pois chiches, fruits de mer, viande rouge</li>
              <li>Vitamines D et A : essentielles au métabolisme folliculaire </li>
              <li>Consommez des fruits et légumes variés pour renforcer l’apport en vitamines et antioxydants. </li>
            </ul>
          </ul>
          <ul>
            <li>Soin du cuir chevelu </li>
            <ul>
              <li>Massez le cuir chevelu chaque jour pour stimuler la circulation et améliorer la santé folliculaire. </li>
              <li>Utilisez un shampooing doux sans sulfates à base d’extraits naturels (palmier nain, romarin, bhringraj, amla).  </li>
              <li>Évitez les traitements chimiques agressifs, le séchage à air chaud et les coiffures qui tirent sur les cheveux. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage4 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Vos photos montrent </h3>
          </div>
          <Typography className="description">
            Vos photos montrent une calvitie étendue sur le dessus du cuir chevelu, où la retraite de la ligne frontale et l’amincissement du sommet se sont rejoints. Seuls quelques cheveux fins subsistent dans la zone centrale, sans assurer une couverture visible.  
          </Typography>
          <Typography className="description mt-10px">
            Ce stade correspond au Norwood 6, une phase avancée d’alopécie androgénétique. Les traitements médicamenteux seuls ne permettent plus de rétablir la densité initiale, mais une prise en charge adaptée reste bénéfique pour préserver les follicules restants et préparer une restauration chirurgicale. 
          </Typography>
          {/* <Typography className="description mt-10px">
            Surgical restoration is now the most effective option, while medical treatment supports donor health and graft survival.
          </Typography> */}
        </CardContent>
      </Card>
    ),
    male_why_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Pourquoi cela arrive </h3>
          </div>
          <Typography className="description">
            La progression de la perte de cheveux est principalement due à une sensibilité génétique à la DHT (dihydrotestostérone).  
          </Typography>
          <ul>
            <li>
              Après la puberté, le taux de testostérone augmente. Environ 10 % de cette testostérone est convertie en DHT par les enzymes 5-alpha-réductase de type I et II. 
            </li>
            <li>
              La DHT se fixe aux récepteurs des follicules pileux et entraîne leur rétrécissement, leur affaiblissement et leur inactivité progressive. 
            </li>
            <li>
              Les zones frontales et du sommet sont particulièrement sensibles à la DHT, ce qui explique leur atteinte précoce et leur progression vers une calvitie complète. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage6 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">Pourquoi cela arrive </h3>
        </div>
        <Typography className="description">
          La progression de la perte de cheveux est principalement due à une sensibilité génétique à la DHT (dihydrotestostérone).
        </Typography>
        <Typography className="description mt-10px">
          Greffe de cheveux : l’option la plus efficace
          Si votre objectif est de rétablir la couverture des zones chauves visibles, la greffecapillaire est actuellement la solution la plus efficace. Il existe deux techniquesprincipales: 
        </Typography>
        <ul>
          <li>FUT (Follicular Unit Transplantation) : un lambeau de cuir chevelu est prélevdans la zone donneuse, puis les unités folliculaires sont implantées dans les zonedégarnies. </li>
          <li>FUE (Follicular Unit Extraction) : les follicules sont prélevés un à un eimplantés directement dans les zones chauves. </li>
        </ul>
        <Typography className="description">
          Chaque méthode présente ses avantages et ses limites ; le choix dépend de l’état du cuir chevelu, de la disponibilité des cheveux donneurs et des préférences personnelles. Réalisée par un chirurgien expérimenté, la taux de succès dépasse souvent 90 %. 
        </Typography>
        <Typography className="description">
          Le coût de l’intervention dépend du nombre de follicules nécessaires, et plusieurs séances peuvent être requises pour obtenir une couverture optimale et naturelle.  
        </Typography>
        <ul>
          <li>Des traitements anti-DHT peuvent être prescrits pour protéger les zones donneuses et favoriser la prise des greffons. </li>
          <li>Des soins à base de peptides ou de nutriments spécifiques peuvent soutenir la régénération et améliorer la qualité du cuir chevelu après la greffe. </li>
        </ul>
        {/* <Typography className="description mt-10px">
          Accéder au traitement sur prescription médicale 
        </Typography> */}
      </>
    ),
    male_what_to_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">À quoi s’attendre</h3>
          </div>
          <ul>
            <li>
              Après une greffe, la couverture peut correspondre à un stade Norwood 3 ou 4.
            </li>
            <li>
              Pour obtenir une densité plus importante, des séances supplémentaires peuvent être nécessaires.
            </li>
            <li>
              Pour maintenir les résultats et protéger les follicules greffés, des bloqueurs de DHT sur prescription peuvent aider à préserver les follicules donneurs et à assurer la bonne santé des greffons transplantés. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    // male_timeline_stage6 : (
    //   <Card className="statCard yourPhotossection">
    //      <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <AccessTimeOutlinedIcon className="cameraIcon" />
    //         <h3 className="photoTitle">Expected timeline with treatment </h3>
    //       </div>
    //       <ul>
    //         <li>
    //           Month 1:  density maintained. 
    //         </li>
    //         <li>
    //           Months 3–6:  No visible changes; subtle improvements in follicle strepossible.
    //         </li>
    //         <li>
    //           Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
    //         </li>
    //       </ul>
    //      </CardContent>
    //   </Card>
    // ),
    // male_lifestyle_stage6 : (
    //   <Card className="statCard yourPhotossection">
    //     <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <h3 className="photoTitle">Lifestyle & daily care support </h3>
    //       </div>
    //       <Typography className="description">While surgery and prescription therapy are the cornerstones, lifestyle choices remain important to support outcomes: </Typography>
    //       <ul>
    //         <li>Nutrition: </li>
    //         <ul>
    //           <li> Biotin — egg yolks, almonds, peanuts, sweet potatoes</li>
    //           <li>Zinc — lentils, cashews, chickpeas, oysters</li>
    //           <li>Vitamins A, D, and E — help strengthen scalp and follicle environment </li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li> Scalp Stimulation:</li>
    //         <ul>
    //           <li>Gentle scalp massage with a silicone massager, 5 minutes daily, improves circulation and aids healing post-transplant.</li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li>Avoid: Smoking, excessive alcohol, chemical styling treatments, and direct trauma to the scalp after surgery. </li>
    //       </ul>
    //       <ul>
    //         <li>Track Progress: Post-transplant regrowth begins at 3–4 months, with major density improvements by 9–12 months. Uploading photos every 3 months through the app ensures accurate tracking. </li>
    //       </ul>
    //     </CardContent>
    //   </Card>
    // ),
    male_legal_stage6 : (
      <Card className="statCard yourPhotossection legalSection stage1">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Vos photos montrent</h3>
          </div>
          <Typography className="description">
            Vos photos montrent une calvitie complète sur le dessus du cuir chevelu : la ligne frontale, la zone médiane et la couronne sont dégarnies, ne laissant qu’une couronne étroite de cheveux à l’arrière et sur les côtés.  
          </Typography>
          <Typography className="description mt-10px">
            Ce stade correspond au Norwood 7, la forme la plus avancée d’alopécie androgénétique. Les traitements médicamenteux seuls ne permettent plus de restaurer la densité, et les options chirurgicales sont limitées par la quantité de cheveux donneurs disponibles. 
          </Typography>
          {/* <Typography className="description mt-10px">
            Cosmetic solutions — such as strategic transplantation, scalp micropigmentation, or hair systems — can still provide visible improvement in appearance.
          </Typography> */}
        </CardContent>
      </Card>
    ),
    male_why_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Pourquoi cela arrive </h3>
          </div>
          <Typography className="description">
            La perte de cheveux à ce stade est due à l’effet prolongé de la DHT (dihydrotestostérone) sur les follicules génétiquement sensibles.  
          </Typography>
          <ul>
            <li>Après la puberté, une partie de la testostérone est convertie en DHT par les enzymes 5-alpha-réductase de type I et II. </li>
            <li>
              Chez les personnes atteintes d’alopécie androgénétique, la DHT se fixe sur les récepteurs des follicules situés sur le sommet et à l’avant du cuir chevelu. 
            </li>
            <li>
              À chaque cycle, les follicules se miniaturisent : les cheveux deviennent plus fins et plus courts jusqu’à ce que la production cesse complètement.  
            </li>
            <li>
              À ce stade, la plupart des follicules du dessus de la tête sont inactifs, tandis que ceux des côtés et de l’arrière, résistants à la DHT, continuent à produire des cheveux. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage7 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">Ce que vous pouvez faire </h3>
        </div>
        <Typography className="description">
          Greffe capillaire : peut être envisagée si la zone donneuse est suffisante. Elle permet de recréer partiellement une ligne frontale ou d’améliorer la couverture. 
        </Typography>
        <Typography className="description mt-10px">
          Traitements médicaux : les bloqueurs de DHT peuvent aider à protéger la zone donneuse et à améliorer la survie des greffons.
        </Typography>
        <Typography className="description mt-10px">
            Solutions non chirurgicales :
        </Typography>
        <ul>
          <li>Micropigmentation du cuir chevelu (SMP) : crée l’apparence d’un crâne rasé plus dense.</li>
          <li>Prothèses capillaires médicales : offrent une apparence de densité lorsque la greffe n’est pas envisageable. </li>
        </ul>
      </>
    ),
    male_what_to_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">À quoi s’attendre</h3>
          </div>
          <ul>
            <li>
              Après une greffe, la couverture peut correspondre à un stade Norwood 3 ou 4.  
            </li>
            <li>
              Pour obtenir une densité plus importante, des séances supplémentaires peuvent être nécessaires.   
            </li>
            <li>
              Pour maintenir les résultats et protéger les follicules greffés, des bloqueurs de DHT sur prescription peuvent aider à préserver les follicules donneurs et à assurer la bonne santé des greffons transplantés.  
            </li>     
          </ul>
        </CardContent>
      </Card>
    ),
    // male_timeline_stage7 : (
    //   <Card className="statCard yourPhotossection">
    //      <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <AccessTimeOutlinedIcon className="cameraIcon" />
    //         <h3 className="photoTitle">Expected timeline with treatment </h3>
    //       </div>
    //       <ul>
    //         <li>
    //           Month 1:  density maintained. 
    //         </li>
    //         <li>
    //           Months 3–6:  No visible changes; subtle improvements in follicle strepossible.
    //         </li>
    //         <li>
    //           Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
    //         </li>
    //       </ul>
    //      </CardContent>
    //   </Card>
    // ),
    // male_lifestyle_stage7 : (
    //   <Card className="statCard yourPhotossection">
    //     <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <h3 className="photoTitle">Lifestyle & daily care support </h3>
    //       </div>
    //       <Typography className="description">Even in advanced stages, supporting scalp and donor health is valuable:</Typography>
    //       <ul>
    //         <li>Nutrition: </li>
    //         <ul>
    //           <li>Biotin — egg yolks, almonds, peanuts, sweet potatoes</li>
    //           <li>Zinc — oysters, chickpeas, lentils, cashews</li>
    //           <li>Balanced intake of vitamins A, D, and E to support scalp condition</li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li>Scalp Care:</li>
    //         <ul>
    //           <li> 
    //             Keep the scalp moisturized and healthy to reduce dryness and irritation. 
    //           </li>
    //           <li> 
    //             Gentle massage can maintain circulation and support post-surgical recovery if transplantation is attempted. 
    //           </li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li>Avoid: Smoking, poor diet, and harsh scalp products that can compromise donor follicle strength. </li>
    //       </ul>
    //       <ul>
    //         <li>Track Progress: Even at Stage 7, continued use of the in-app tracker ensures that scalp condition and any treatment outcomes (transplant, SMP, or systems) are monitored visually. </li>
    //       </ul>
    //     </CardContent>
    //   </Card>
    // ),
    male_legal_stage7 : (
      <Card className="statCard yourPhotossection legalSection stage1">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos reveal no visible thinning. Hair appears full and dense, with the central parting remaining narrow and the scalp well covered.
          </Typography>
          <Typography className="description mt-10px">
            Some women take the test at this stage because of increased shedding or a loss of styling volume, even though thinning is not yet visible. These concerns are important, as they may represent the earliest signals of change. 
          </Typography>
          <Typography className="description mt-10px">
            Women at this stage who begin preventive care are more likely to maintain full density and delay the onset of visible thinning.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            Losing up to 100 hairs per day is normal and should not be a cause for alarm. However, in women with a genetic predisposition, the balance of hormones and follicle sensitivity can gradually change over time. 
          </Typography>
          <ul>
            <li>
              Family history plays an important role. If close female relatives experienced thinning, the risk is higher. </li>
            <li>
              Oestrogen normally protects the follicles. It prolongs the growth phase of the hair cycle and helps maintain density. 
            </li>
            <li>
              After menopause, declining oestrogen levels reduce this protection, and follicles become more vulnerable. 
            </li>
            <li>
              Even though women produce much lower levels of testosterone than men, a small fraction is converted into dihydrotestosterone (DHT).  
            </li>
            <li>
              In sensitive follicles, DHT binds to receptors and begins the process of miniaturisation: hairs grow back finer, the active growth phase shortens, and resting phases lengthen. 
            </li>
            <li>
              Over the years, this cycle can lead to progressive thinning — most often visible along the central parting and crown, which defines the Sinclair pattern of female hair loss. 
            </li>
          </ul>
          <Typography className="description">
            At Stage 1, your hair coverage is still excellent. But understanding these mechanisms explains why early vigilance or preventive treatment is often recommended, especially if there is family history.  
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage0 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>Preventive prescription care can help protect follicles before visible thinning begins.</li>
          <li>Monitoring is an option if you prefer to wait — we recommend repeating the test in 6 months. </li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    female_timeline_stage0 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Shedding may stabilise
            </li>
            <li>
              Month 3–6: Subtle thickening possible 
            </li>
            <li>
              Month 6+: Maintenance of density and delayed onset of thinning 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs) </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Also include fruits, vegetables, and protein-rich foods. 
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoo (rosemary or lavender extracts may help).</li>
              <li>Massage the scalp gently with a silicone massager. </li>
              <li>Avoid harsh dyes, frequent bleaching, and heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Prioritise sleep and manage stress (yoga, meditation, deep breathing). </li>
              <li>Avoid smoking, which reduces blood flow and accelerates hair loss. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage0 : (
      <Card className="statCard yourPhotossection legalSection stage1">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos reveal mild widening of the central parting, with slightly less density visible compared to Stage 1. Hair remains overall full, but subtle changes in volume may be noticeable when styling. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 2 on the Sinclair scale, often considered the earliest visible stage of female pattern hair loss. Many women first become aware of thinning at this point, particularly when comparing photos or noticing more scalp visibility under bright light. 
          </Typography>
          <Typography className="description mt-10px">
            Women who start medical treatment at Stage 2 often stabilise shedding quickly and preserve visible density long term.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            At Stage 2, the first visible signs of follicle miniaturisation appear. While daily shedding may still be within the normal range, the regrown hairs are no longer the same as those lost: 
          </Typography>
          <ul>
            <li>Hairs grow back finer and shorter, leading to a gradual reduction in volume.</li>
            <li>
              The central parting begins to widen as miniaturised hairs provide less coverage.
            </li>
            <li>
              After menopause, levels of oestrogen and progestogen naturally decline, while male-type hormones (androgens) may exert more influence. 
            </li>
            <li>
              If your follicles are particularly sensitive to these hormones — especially dihydrotestosterone (DHT) — this can trigger or accelerate hair loss. 
            </li>
          </ul>
          <Typography className="description">
            This stage marks the shift from invisible shedding to visible thinning, making it a crucial moment to begin preventive or corrective measures. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage1 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>Prescription anti-androgen therapy can block follicle sensitivity to DHT and preserve thickness. </li>
          <li>Topical or oral treatments may stimulate regrowth of miniaturised hairs.</li>
          <li>Regular monitoring with repeat tests every 2 months will help track stability and guide adjustments.</li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    female_timeline_stage1 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Shedding stabilises 
            </li>
            <li>
              Month 3–6: Visible regrowth and improved density often begin 
            </li>
            <li>
              Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs)  </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Support with fruits, vegetables, and protein-rich foods.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoos; rosemary or lavender extracts may provide mild supportive benefits. </li>
              <li>Massage the scalp daily with a silicone massager to stimulate blood flow. </li>
              <li>Avoid harsh dyes, chemical treatments, or frequent heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Prioritise sleep and manage stress with yoga, meditation, or relaxation techniques.</li>
              <li>
                Avoid smoking, which worsens microcirculation and accelerates miniaturisation. 
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage1 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a noticeable widening of the central parting, with the scalp more visible compared to Stage 2. Hair density in the frontal and crown regions appears reduced, though overall coverage remains. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 3 on the Sinclair scale, where thinning becomes obvious under normal lighting conditions. Many women at this stage report difficulty maintaining the same hairstyles, reduced volume, and more visible scalp in photos.
          </Typography>
          <Typography className="description mt-10px">
            Women at Stage 3 who start treatment often see significant improvement in density within 6–12 months.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            At Stage 3, the process of follicle miniaturisation becomes much more visible. 
          </Typography>
          <ul>
            <li>
              The scalp shows clearly through the central parting, and thinning is noticeable in normal lighting. 
            </li>
            <li>
              Miniaturised hairs are thinner and shorter, which reduces their ability to provide volume and coverage.
            </li>
            <li>
              After menopause, the decline in oestrogen and progestogen removes much of the natural protection that previously helped maintain density. 
            </li>
            <li>
              This shift allows androgens, particularly dihydrotestosterone (DHT), to play a more prominent role, further accelerating the miniaturisation process.  
            </li>
            <li>
              The hair cycle becomes imbalanced: the growth phase shortens, while the resting phase lengthens, resulting in continuous shedding without full replacement. 
            </li>
            <li>
              This is a widespread process: over 40% of women experience some form of alopecia after menopause, showing how common and hormonally driven this condition is. 
            </li>
          </ul>
          <Typography className="description">
            At Stage 3, the process is still highly manageable with treatment — but if ignored, progression to more advanced stages becomes likely. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage2 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>Prescription anti-androgen therapies (oral or topical) can significantly slow or halt progression. </li>
          <li>Combination approaches (medical + supportive care) give the best chance of visible thickening. </li>
          <li>Follow-up testing every 2 months is recommended to track changes and adjust treatment. </li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    female_timeline_stage2 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Stabilisation of shedding 
            </li>
            <li>
              Month 3–6: New regrowth begins to appear 
            </li>
            <li>
              Month 6–12: Visible thickening, improved volume, and reduction in scalp visibility 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs) </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Support with fruits, vegetables, and protein-based meals.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoos; natural options with rosemary or lavender may support scalp health. </li>
              <li>Perform gentle scalp massage daily to stimulate circulation (unless using prescription topicals). </li>
              <li>Avoid harsh chemical treatments and high-heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Ensure adequate sleep and manage stress through yoga, meditation, or relaxation.  </li>
              <li>
                Do not smoke, as it reduces scalp blood flow and accelerates miniaturisation. 
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage2 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a marked widening of the central parting, with the scalp clearly visible. Hair in the crown and mid-frontal areas shows reduced density, though lateral and occipital (back) regions remain well preserved. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 4 on the Sinclair scale, where thinning is significant enough to be noticed in casual settings, often causing distress and changes in hairstyle to mask scalp visibility. 
          </Typography>
          <Typography className="description mt-10px">
            Women at Stage 4 who commit to medical treatment often stabilise progression and achieve visible thickening within 6–12 months.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            By Stage 4, the process of follicle miniaturisation has advanced significantly. 
          </Typography>
          <ul>
            <li>The central parting is markedly widened, and thinning now extends beyond the midline into surrounding areas of the scalp. </li>
            <li>
              Miniaturised hairs dominate, producing strands that are progressively finer, weaker, and less pigmented. 
            </li>
            <li>
              With the continued decline of oestrogen and progestogen, follicles lose their natural hormonal protection, leaving them increasingly vulnerable to androgenic influence.  
            </li>
            <li>
              Even at the lower androgen levels typical in women, DHT is sufficient to drive follicular shrinkage, leading to a progressive reduction in both hair thickness and coverage. 
            </li>
            <li>
              The growth cycle becomes more disrupted: fewer hairs enter the anagen (growth) phase, while more shift into telogen (resting), which accelerates visible loss. 
            </li>
            <li>
              By this stage, the process is part of a well-recognised pattern: more than 40% of women will develop alopecia after menopause, reflecting the loss of hormonal protection and increasing follicular vulnerability.
            </li>
          </ul>
          <Typography className="description">
            At this stage, the loss of volume is substantial, and the scalp is conspicuous in most lighting conditions. Intervention is essential to preserve the remaining density and slow further progression. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage3 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>Medical treatment is strongly recommended at this stage to preserve remaining active follicles.</li>
          <li>Anti-androgen therapies (oral or topical) help block DHT activity and extend growth phases. </li>
          <li>Combination therapy — prescription + lifestyle measures — offers the best chance of visible recovery. </li>
          <li>Ongoing monitoring with repeat tests every 2 months is essential to track treatment effectiveness. </li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    female_timeline_stage3 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Stabilisation of shedding 
            </li>
            <li>
              Month 3–6: Thickening of miniaturised hairs 
            </li>
            <li>
              Month 6–12: Visible improvement in scalp coverage and parting density 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs)  </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish)
                Add fresh fruits, vegetables, and protein for balanced support.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>
                Use sulphate-free shampoos; rosemary or lavender extracts may be beneficial. 
              </li>
              <li>Gentle daily scalp massage can support circulation. </li>
              <li>Avoid frequent bleaching, dyes, or excessive heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Ensure adequate sleep and stress reduction practices (yoga, meditation).  </li>
              <li>Avoid smoking, as it impairs microcirculation and accelerates miniaturisation. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage3 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos reveal severe widening of the central parting, with large areas of scalp visible. The crown and mid-frontal zones are extensively affected, though the back and sides remain relatively preserved. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 5 on the Sinclair scale, where thinning is obvious in all lighting conditions. Many women at this stage experience loss of volume, difficulty styling, and a strong emotional impact due to the visibility of the condition. 
          </Typography>
          <Typography className="description mt-10px">
            Women who begin medical treatment at Stage 5 may still achieve visible thickening, but preserving the remaining follicles is the most urgent goal.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            At Stage 5, the process of miniaturisation has reached an advanced level, and the impact on coverage is significant.
          </Typography>
          <ul>
            <li>The central parting is wide and diffuse, with thinning extending well beyond the midline into larger areas of the scalp. </li>
            <li>
              Miniaturised hairs are now the majority, producing strands that are thin, fragile, and often lack pigmentation. 
            </li>
            <li>
              The continued decline of oestrogen and progestogen after menopause removes almost all protective influence on the follicles. 
            </li>
            <li>
              In this context, even modest levels of androgens (particularly DHT) exert a strong effect, accelerating shrinkage and shortening the growth phase. 
            </li>
            <li>
              The anagen (growth) phase is progressively curtailed, while the telogen (resting) phase dominates, leading to a steady reduction in hair count and quality.
            </li>
            <li>
              By this stage, many follicles enter a prolonged dormancy, and some may cease producing visible hairs altogether. 
            </li>
          </ul>
          <Typography className="description">
            This explains why Stage 5 represents a severe form of female pattern hair loss. The scalp is highly visible in nearly all lighting conditions, and spontaneous recovery is unlikely. Medical intervention is essential at this point to maintain remaining density and prevent further irreversible progression.  
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage4 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>Immediate medical treatment is strongly advised. Prescription therapies can reduce androgen sensitivity and reactivate dormant follicles. </li>
          <li>Combination therapy (systemic + topical anti-androgens, plus supportive care) offers the best chance of visible improvement. </li>
          <li>Regular monitoring every 2 months is necessary to track progress and adjust treatment.</li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    female_timeline_stage4 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Stabilisation of shedding  
            </li>
            <li>
              Month 3–6: Reactivation of weakened follicles, with early regrowth 
            </li>
            <li>
              Month 6–12: Visible thickening and improved scalp coverage, though full restoration may not be possible 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs) </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Balanced diet with fruits, vegetables, and protein-rich foods is essential.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>
                Stick to sulphate-free shampoos, ideally with natural supportive ingredients. 
              </li>
              <li>Gentle scalp massage daily can improve circulation, unless contraindicated by topical therapy. </li>
              <li>Avoid frequent bleaching, dyes, or heavy heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Maintain regular sleep cycles and manage stress through meditation or yoga. </li>
              <li>Quit smoking, as it reduces blood flow and accelerates follicle loss. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage4 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
  })

  const [masterJsonEs] = useState({
    male_photos_description_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Tus fotos muestran </h3>
          </div>
          <Typography className="description">
            Tus fotos muestran una línea frontal completa e intacta, sin adelgazamiento visible en las sienes ni en la coronilla. En esta etapa, la densidad capilar es normal y no hay signos evidentes de pérdida. 
          </Typography>
          <Typography className="description mt-10px">
            Probablemente realizaste esta prueba porque notas una caída de cabello más abundante de lo habitual. Es normal perder alrededor de 100 cabellos al día, pero una caída mayor puede indicar las primeras fases de una alopecia androgenética, incluso antes de que sea visible.
          </Typography>
          <Typography className="description mt-10px">
            Comenzar un cuidado preventivo desde ahora puede ayudar a preservar la densidad natural y retrasar cualquier progresión futura. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Por qué ocurre </h3>
          </div>
          <Typography className="description">
            Aunque el cuero cabelludo parezca normal en la etapa 1, el proceso biológico de la alopecia androgenética puede haber comenzado bajo la superficie. 
          </Typography>
          <ul>
            <li>Después de la pubertad, los niveles de testosterona aumentan. Aproximadamente el 10 % de esta testosterona se convierte en DHT (dihidrotestosterona) mediante las enzimas 5-alfa reductasa tipo I y II. </li>
            <li>
              En las personas sensibles, la DHT se une a los receptores de los folículos pilosos y provoca su encogimiento progresivo. 
            </li>
            <li>
              Esto genera cabellos más finos y frágiles, una fase de crecimiento (anágena) más corta y un mayor número de folículos que entran en fase de reposo (telógena), lo que resulta en una caída aumentada y una regeneración más lenta. 
            </li>
            <li>
              Con el tiempo, algunos folículos se vuelven inactivos y pierden la capacidad de producir cabello nuevo. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage0 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">Qué puedes hacer </h3>
        </div>
        <ul>
          <li>Puede recomendarse un tratamiento preventivo si tienes antecedentes familiares de calvicie o si ya se detecta un adelgazamiento microscópico. </li>
          <li>Mantener un estilo de vida saludable y una alimentación equilibrada ayuda a fortalecer los folículos y a retrasar la pérdida visible. </li>
          <li>Los pacientes que inician un tratamiento en esta fase suelen mantener su densidad natural durante muchos años. </li>
        </ul>
        {/* <Typography className="description mt-10px">
          Acceder al tratamiento con prescripción médica 
        </Typography> */}
      </>
    ),
    male_timeline_stage0 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Cronología esperada con un cuidado preventivo </h3>
          </div>
          <ul>
            <li>
              Mes 1: densidad mantenida. 
            </li>
            <li>
              Meses 3 – 6: sin cambios visibles; es posible una mejora sutil en la fortaleza de los folículos. 
            </li>
            <li>
              Meses 6 – 12: el seguimiento a largo plazo permite detectar cualquier cambio temprano y tratarlo a tiempo. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Consejos de estilo de vida y cuidado diario </h3>
          </div>
          <Typography className="description"> En esta etapa inicial, los cuidados de apoyo pueden ser suficientes para mantener los folículos fuertes. Esto incluye una nutrición adecuada y una buena rutina de cuidado del cuero cabelludo.</Typography>
          <ul>
            <li>Nutrición</li>
            <Typography className="description">Una dieta rica en proteínas —la queratina es el principal componente del cabello— y en micronutrientes es esencial:</Typography>
            <ul>
              <li>Biotina: yema de huevo, cacahuetes, almendras, batata </li>
              <li>Zinc: garbanzos, anacardos, ostras, lentejas </li>
              <li>Hierro: lentejas, garbanzos, mariscos, carne roja </li>
              <li>Vitaminas D y A: esenciales para el metabolismo folicular </li>
            </ul>
          </ul>
          <ul>
            <li>Cuidado del cuero cabelludo </li>
            <ul>
              <li> Masajea suavemente el cuero cabelludo con un masajeador de silicona para estimular la circulación. </li>
              <li> Evita los tintes agresivos, el uso de secadores con aire caliente y los peinados que tiren con fuerza del cabello. </li>
              <li> Utiliza un champú suave elaborado con ingredientes naturales que tengan una ligera actividad anti-DHT (bhringraj, amla, serenoa repens, romero). </li>
            </ul>
          </ul>
          <ul>
            <li>Estilo de vida </li>
            <ul>
              <li>
                Evita fumar, ya que acelera el adelgazamiento del cabello. 
              </li>
              <li>
                Duerme lo suficiente y controla el estrés.  
              </li>
              <li>
                Realiza un seguimiento de tu progreso subiendo fotos del cuero cabelludo cada 6 a 12 meses para observar posibles cambios en la densidad. 
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage0 : (
      <Card className="statCard yourPhotossection legalSection stage1">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Tus fotos muestran </h3>
          </div>
          <Typography className="description">
            Tus fotos muestran un leve retroceso de la línea frontal en la zona de las sienes, mientras que la coronilla y la parte superior del cuero cabelludo mantienen buena densidad. Esta etapa corresponde al Norwood 2, donde aparecen los primeros signos visibles de retroceso capilar. Probablemente hayas notado que tu frente parece más amplia o que algunos peinados dejan más expuestas las sienes.  
          </Typography>
          <Typography className="description mt-10px">
            En esta fase, la pérdida es mínima y puede revertirse si se trata a tiempo. 
          </Typography>
          <Typography className="description mt-10px">
            Los hombres que inician tratamiento preventivo en esta etapa suelen estabilizar la caída y conservar su densidad natural durante muchos años. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Por qué ocurre </h3>
          </div>
          <Typography className="description">
            En la etapa 2, los primeros signos visibles de miniaturización folicular comienzan a aparecer.
          </Typography>
          <ul>
            <li>
              Después de la pubertad, los niveles de testosterona aumentan. Aproximadamente el 10 % de esta testosterona se convierte en DHT (dihidrotestosterona) mediante las enzimas 5-alfa reductasa tipo I y II. 
            </li>
            <li>
              La DHT se une a los receptores de los folículos pilosos, especialmente en las sienes, y provoca su encogimiento progresivo. 
            </li>
            <li>
              Esto da lugar a cabellos más finos y cortos, lo que genera la impresión de una línea frontal más alta.  
            </li>
            <li>
              La fase de crecimiento (anágena) se acorta, mientras que la fase de reposo (telógena) se alarga, haciendo que la pérdida sea más visible con el tiempo. 
            </li>
          </ul>
          <Typography className="description">
            La etapa 2 es, por tanto, el momento ideal para actuar: la intervención temprana puede detener la miniaturización antes de que progrese. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_what_stage1 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">Qué puedes hacer </h3>
        </div>
        <ul>
          <li>Un médico puede recetar un tratamiento anti-DHT para proteger los folículos sensibles y preservar la densidad existente. </li>
          <li>Los tratamientos tópicos o los péptidos capilares pueden combinarse para fortalecer los cabellos y mejorar la vitalidad del cuero cabelludo. </li>
          <li>Mantener un estilo de vida saludable —con sueño adecuado, buena alimentación, manejo del estrés y sin tabaco— favorece la salud del folículo y los resultados a largo plazo. </li>
        </ul>
        <Typography className="description mt-10px">
          Acceder al tratamiento con prescripción médica 
        </Typography>
      </>
    ),
    male_timeline_stage1 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Cronología esperada con el tratamiento </h3>
          </div>
          <ul>
            <li>
              Meses 1 – 2: estabilización de la caída.  
            </li>
            <li>
              Meses 3 – 6: los folículos de las sienes comienzan a producir cabellos más fuertes y gruesos. 
            </li>
            <li>
              Meses 6 – 12: restauración visible de la línea frontal y mejora de la densidad.  
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Consejos de estilo de vida y cuidado diario </h3>
          </div>
          <Typography className="description">En esta etapa temprana, los cuidados regulares pueden ser suficientes para mantener la salud del folículo. Incluyen una nutrición adecuada y una buena rutina de cuidado del cuero cabelludo. </Typography>
          <ul>
            <li>Nutrición</li>
            <ul>
              <Typography className="description">Una alimentación rica en proteínas y micronutrientes ayuda a mantener el crecimiento capilar:</Typography> 
              <li>Zinc: garbanzos, anacardos, ostras, lentejas </li>
              <li>Hierro: lentejas, garbanzos, mariscos, carne roja </li>
              <li>Vitaminas D y A: esenciales para el metabolismo folicular </li>
              <li>Incluye frutas y verduras variadas para un aporte completo de antioxidantes y vitaminas. </li>
            </ul>
          </ul>
          <ul>
            <li>Cuidado del cuero cabelludo </li>
            <ul>
              <li>Masajea suavemente el cuero cabelludo cada día para estimular la microcirculación. </li>
              <li>Usa un champú suave, sin sulfatos, formulado con ingredientes naturales (serenoa repens, romero, bhringraj, amla). </li>
              <li>Evita los tintes agresivos y el uso excesivo de secadores o planchas. </li>
            </ul>
          </ul>
          <ul>
            <li>Estilo de vida </li>
            <ul>
              <li>Evita fumar, ya que acelera el adelgazamiento capilar. </li>
              <li>Duerme lo suficiente y controla el estrés. </li>
              <li>Realiza un seguimiento fotográfico cada 3 meses para detectar los primeros cambios. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage1 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Tus fotos muestran </h3>
          </div>
          <Typography className="description">
            Tus fotos muestran un retroceso más notable de la línea frontal, especialmente en la zona de las sienes. La densidad es menor en la parte frontal del cuero cabelludo, mientras que la coronilla conserva buena cobertura. 
          </Typography>
          <Typography className="description mt-10px">
            Esta etapa corresponde al Norwood 3, donde los signos de calvicie son visibles a simple vista. Es probable que notes una pérdida de volumen o mayor dificultad para peinarte como antes. 
          </Typography>
          <Typography className="description mt-10px">
            Los hombres que comienzan tratamiento en esta fase suelen estabilizar la caída y recuperar densidad visible en pocos meses. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Por qué ocurre </h3>
          </div>
          <Typography className="description">
            En la etapa 3, el proceso de miniaturización de los folículos ya está bien establecido.  
          </Typography>
          <ul>
            <li>Después de la pubertad, los niveles de testosterona aumentan. Aproximadamente el 10 % de esta testosterona se convierte en DHT (dihidrotestosterona) mediante las enzimas 5-alfa reductasa tipo I y II. </li>
            <li>
              En las personas genéticamente sensibles, la DHT se une a los receptores de los folículos pilosos, lo que provoca su encogimiento progresivo. 
            </li>
            <li>
              Esto genera cabellos más finos y frágiles, una fase de crecimiento (anágena) más corta y un mayor número de folículos que entran en fase de reposo (telógena). 
            </li>
            <li>
              Con el tiempo, algunos folículos se vuelven inactivos y pierden la capacidad de producir nuevo cabello. 
            </li>
          </ul>
          {/* <Typography className="description">
            This explains why Stage 3 is such an important intervention point: the temples are highly sensitive to DHT, and visible hairline recession is a clear sign that miniaturization is well underway. Acting early can still preserve most of the follicles, restore visible thickness, and prevent progression into more advanced stages.
          </Typography> */}
        </CardContent>
      </Card>
    ),
    male_what_stage2 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">Qué puedes hacer </h3>
        </div>
        {/* <Typography className="description">
          You should begin a clinically proven, doctor-prescribed DHT-blocking treatment, often combined with targeted peptides. These therapies:
        </Typography> */}
        <ul>
          <li>Un médico puede recetar un tratamiento anti-DHT para bloquear la acción hormonal sobre los folículos sensibles y preservar la densidad. </li>
          <li>Los tratamientos tópicos o los péptidos capilares pueden combinarse para estimular el crecimiento y reforzar la fibra capilar. </li>
          <li>Un seguimiento regular, con fotos cada 2 o 3 meses, ayuda a evaluar la estabilidad y ajustar el protocolo cuando sea necesario. </li>
        </ul>
        <Typography className="description mt-10px">
          Acceder al tratamiento con prescripción médica 
        </Typography>
        {/* <Typography className="description">
          A licensed doctor will review your case, confirm the stage, and prescribe the most effective treatment plan.
        </Typography> */}
      </>
    ),
    male_timeline_stage2 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Cronología esperada con el tratamiento </h3>
          </div>
          <ul>
            <li>
              Meses 1 – 2: estabilización de la caída. 
            </li>
            <li>
              Meses 3 – 6: comienzo de la repoblación capilar, especialmente en las sienes. 
            </li>
            <li>
              Meses 6 – 12: engrosamiento visible de la línea frontal y mejora de la densidad general.  
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Consejos de estilo de vida y cuidado diario </h3>
          </div>
          <Typography className="description">En esta etapa, el tratamiento médico es esencial, pero los cuidados complementarios ayudan a optimizar los resultados. </Typography>
          <ul>
            <li>Nutrición</li>
            <Typography className="description">Una alimentación rica en proteínas y nutrientes esenciales favorece la salud capilar: </Typography>
            <ul>
              <li>Biotina: yema de huevo, cacahuetes, almendras, batata </li>
              <li>Zinc: garbanzos, anacardos, ostras, lentejas </li>
              <li>Hierro: lentejas, garbanzos, mariscos, carne roja </li>
              <li>Vitaminas D y A: necesarias para el metabolismo folicular </li>
            </ul>
          </ul>
          <ul>
            <li>Cuidado del cuero cabelludo </li>
            <ul>
              <li>
                Masajea el cuero cabelludo todos los días para estimular la microcirculación.
              </li>
              <li>Usa un champú suave sin sulfatos, formulado con ingredientes naturales (serenoa repens, romero, bhringraj, amla). </li>
              <li>Evita los tintes agresivos, el calor excesivo y los peinados muy tirantes. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage2 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Tus fotos muestran</h3>
          </div>
          <Typography className="description">
            Tus fotos muestran un ensanchamiento notable de la raya central, con el cuero cabelludo claramente visible. La densidad es menor en la zona frontal y superior, mientras que las áreas laterales y la parte posterior aún mantienen buena cobertura. 
          </Typography>
          <Typography className="description mt-10px">
            Esta etapa corresponde al Norwood 4, donde la pérdida de cabello se vuelve evidente incluso en situaciones cotidianas. Es probable que notes una mayor exposición del cuero cabelludo y dificultad para mantener el mismo estilo de peinado.  
          </Typography>
          <Typography className="description mt-10px">
            Los hombres que inician tratamiento en esta fase suelen estabilizar la caída y conseguir una mejora visible de la densidad en 6 a 12 meses.
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Por qué ocurre </h3>
          </div>
          <Typography className="description">
            La progresión de la pérdida de cabello se debe principalmente a la sensibilidad genética a la DHT (dihidrotestosterona).  
          </Typography>
          <ul>
            <li>
              Después de la pubertad, los niveles de testosterona aumentan. Aproximadamente el 10 % de esa testosterona se convierte en DHT mediante las enzimas 5-alfa reductasa tipo I y II. 
            </li>
            <li>
              La DHT se une a los receptores de los folículos pilosos, lo que provoca su encogimiento, debilitamiento y, con el tiempo, su inactividad. 
            </li>
            <li>
              Las sienes y la coronilla son especialmente sensibles a la DHT, lo que explica por qué estas zonas suelen ser las primeras en mostrar signos de pérdida capilar. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage3 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">Qué puedes hacer </h3>
        </div>
        <ul>
          <li>Un médico puede recetar un tratamiento anti-DHT para proteger los folículos aún activos y favorecer la regeneración capilar. </li>
          <li>Los tratamientos tópicos o los péptidos capilares pueden combinarse para reforzar los cabellos existentes. </li>
          <li>Un seguimiento regular, con fotografías cada 2 a 3 meses, permite evaluar la respuesta y ajustar el tratamiento según sea necesario. </li>
        </ul>
        <Typography className="description mt-10px">
          Acceder al tratamiento con prescripción médica 
        </Typography>
      </>
    ),
    male_timeline_stage3 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Cronología esperada con el tratamiento </h3>
          </div>
          <ul>
            <li>
              Meses 1 – 2: estabilización de la caída. 
            </li>
            <li>
              Meses 3 – 6: los cabellos se vuelven más fuertes y gruesos. 
            </li>
            <li>
              Meses 6 – 12: mejora visible en la cobertura y en la textura del cabello. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Consejos de estilo de vida y cuidado diario </h3>
          </div>
          {/* <Typography className="description"> In addition to prescription treatment, supportive measures are crucial to maximize results: </Typography> */}
          <ul>
            <li>Nutrición</li>
            <Typography className="description">Una dieta equilibrada, rica en proteínas y micronutrientes, apoya la salud del cuero cabelludo:</Typography>
            <ul>
              <li>Biotina: yema de huevo, cacahuetes, almendras, batata </li>
              <li>Zinc: garbanzos, anacardos, ostras, lentejas </li>
              <li>Hierro: lentejas, garbanzos, mariscos, carne roja </li>
              <li>Vitaminas D y A: esenciales para el metabolismo folicular</li>
              <li>Añade frutas y verduras variadas para un mejor aporte de antioxidantes y vitaminas. </li>
            </ul>
          </ul>
          <ul>
            <li> Cuidado del cuero cabelludo </li>
            <ul>
              <li>Masajea el cuero cabelludo cada día para estimular la microcirculación. </li>
              <li>Usa un champú suave sin sulfatos con ingredientes naturales (serenoa repens, romero, bhringraj, amla). </li>
              <li>Evita coloraciones agresivas, el calor excesivo y los peinados que tensen el cabello. </li>
            </ul>
          </ul>
          <ul>
            <li> Estilo de vida  </li>
            <ul>
              <li>Evita fumar, ya que acelera el adelgazamiento del cabello. </li>
              <li>Duerme lo suficiente y maneja el estrés. </li>
              <li>Haz un seguimiento de tu progreso con fotografías cada 3 a 6 meses. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage3 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Tus fotos muestran </h3>
          </div>
          <Typography className="description">
            Tus fotos muestran una pérdida de cabello avanzada, con adelgazamiento visible tanto en la parte frontal como en la coronilla. Las zonas frontal y superior comienzan a unirse, mientras que los laterales y la parte posterior aún mantienen buena densidad. 
          </Typography>
          <Typography className="description mt-10px">
            Esta etapa corresponde al Norwood 5, donde la pérdida de cabello se vuelve difícil de disimular sin tratamiento. Es probable que notes una mayor exposición del cuero cabelludo bajo la luz y una reducción general del volumen. 
          </Typography>
          <Typography className="description mt-10px">
            Los hombres que comienzan tratamiento en esta fase aún pueden preservar los folículos activos y mejorar visiblemente la cobertura capilar. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Por qué ocurre </h3>
          </div>
          <Typography className="description">
            La progresión de la pérdida de cabello se debe principalmente a la sensibilidad genética a la DHT (dihidrotestosterona). 
          </Typography>
          <ul>
            <li>
              Después de la pubertad, los niveles de testosterona aumentan. Aproximadamente el 10 % de esa testosterona se convierte en DHT mediante las enzimas 5-alfa reductasa tipo I y II.  </li>
            <li>
              La DHT se une a los receptores de los folículos pilosos, lo que provoca su encogimiento, debilitamiento y, con el tiempo, su inactividad. 
            </li>
            <li>
              Las sienes y la coronilla son especialmente sensibles a la DHT, lo que explica por qué estas áreas suelen ser las primeras en mostrar signos de pérdida capilar. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage4 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">Qué puedes hacer </h3>
        </div>
        <ul>
          <li>Un médico puede recetar un tratamiento médico dirigido para reducir la acción de la DHT y proteger los folículos aún activos. </li>
          <li>Los tratamientos tópicos y los cuidados complementarios pueden apoyar la repoblación y fortalecer los cabellos existentes. </li>
          <li>En esta etapa, una consulta especializada es importante para evaluar la posibilidad de un trasplante capilar u otras soluciones adaptadas. </li>
        </ul>
        <Typography className="description mt-10px">
          Acceder al tratamiento con prescripción médica 
        </Typography>
      </>
    ),
    male_timeline_stage4 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Cronología esperada con el tratamiento </h3>
          </div>
          <ul>
            <li>
              Meses 1 – 2: estabilización de la caída. 
            </li>
            <li>
              Meses 3 – 6: el cabello se vuelve más grueso y mejora la cobertura. 
            </li>
            <li>
              Meses 6 – 12: densidad reforzada y reducción de la visibilidad del cuero cabelludo. 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    male_lifestyle_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Consejos de estilo de vida y cuidado diario </h3>
          </div>
          <ul>
            <li>Nutrición </li>
            <Typography className="description"> Una dieta equilibrada y rica en proteínas y micronutrientes es fundamental para mantener la salud del cabello: </Typography>
            <ul>
              <li>Biotina: yema de huevo, cacahuetes, almendras, batata </li>
              <li>Zinc: garbanzos, anacardos, ostras, lentejas </li>
              <li>Hierro: lentejas, garbanzos, mariscos, carne roja </li>
              <li>Vitaminas D y A: esenciales para el metabolismo folicular </li>
              <li>Incluye frutas y verduras variadas para un mejor aporte de antioxidantes y vitaminas. </li>
            </ul>
          </ul>
          <ul>
            <li>Cuidado del cuero cabelludo </li>
            <ul>
              <li>Masajea el cuero cabelludo cada día para estimular la circulación y fortalecer los folículos. </li>
              <li>Usa un champú suave sin sulfatos elaborado con ingredientes naturales (serenoa repens, romero, bhringraj, amla). </li>
              <li>Evita tratamientos químicos agresivos, calor excesivo o peinados que tiren del cabello. </li>
            </ul>
          </ul>
          <ul>
            <li>Estilo de vida  </li>
            <ul>
              <li>
                Duerme lo suficiente y maneja el estrés para mantener el equilibrio hormonal. 
              </li>
              <li>Evita fumar, ya que el tabaco reduce la circulación en el cuero cabelludo y acelera la miniaturización. </li>
              <li>Realiza un seguimiento de tu progreso con fotos periódicas. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    male_legal_stage4 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Tus fotos muestran </h3>
          </div>
          <Typography className="description">
            Tus fotos muestran una calvicie extensa en la parte superior del cuero cabelludo, donde el retroceso de la línea frontal y el adelgazamiento del vértice se han unido. Solo quedan algunos cabellos finos en la zona central, sin proporcionar una cobertura visible. 
          </Typography>
          <Typography className="description mt-10px">
            Esta etapa corresponde al Norwood 6, una fase avanzada de alopecia androgenética. En este punto, los tratamientos médicos por sí solos no pueden restaurar la densidad, pero un enfoque combinado puede ayudar a preservar los folículos restantes y preparar el cuero cabelludo para una restauración quirúrgica. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Por qué ocurre </h3>
          </div>
          <Typography className="description">
            La progresión de la pérdida de cabello se debe principalmente a la sensibilidad genética a la DHT (dihidrotestosterona).
          </Typography>
          <ul>
            <li>
              Después de la pubertad, los niveles de testosterona aumentan. Aproximadamente el 10 % de esa testosterona se convierte en DHT mediante las enzimas 5-alfa reductasa tipo I y II. </li>
            <li>
              La DHT se une a los receptores de los folículos pilosos, lo que provoca su encogimiento, debilitamiento y, con el tiempo, su inactividad. 
            </li>
            <li>
              Las zonas frontales y del vértice son especialmente sensibles a la DHT, lo que explica su afectación temprana y su progresión hacia una calvicie más extensa. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage6 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">Qué puedes hacer </h3>
        </div>
        <Typography className="description">
          Trasplante capilar: la opción más eficaz 
        </Typography>
        <Typography className="description mt-10px">
          Si tu objetivo es restaurar la cobertura en las áreas visiblemente calvas, el trasplante capilar es actualmente la solución más efectiva. Existen dos técnicas principales:
        </Typography>
        <ul>
          <li>
            FUT (Trasplante de Unidades Foliculares): se extrae una tira del cuero cabelludo de la zona donante y se implantan las unidades foliculares en las áreas sin cabello. 
          </li>
          <li>
            FUE (Extracción de Unidades Foliculares): los folículos se extraen uno por uno directamente de la zona donante y se implantan en las zonas calvas. 
          </li>
        </ul>
        <Typography className="description mt-10px">
          Ambos métodos tienen sus ventajas y limitaciones. La elección depende del estado del   cuero cabelludo, la disponibilidad de cabello donante y las preferencias personales.  Cuando se realiza por un cirujano experimentado, la tasa de éxito suele superar el 90 %. 
        </Typography>
        <Typography className="description mt-10px">
          El costo del trasplante depende del número de folículos necesarios, y pueden ser necesarias varias sesiones para lograr una cobertura óptima y un resultado natural. 
        </Typography>
        <ul>
          <li>
            Los tratamientos anti-DHT pueden recetarse para proteger la zona donante y favorecer la supervivencia de los injertos. 
          </li>
          <li>
            Los tratamientos con péptidos o suplementos específicos pueden apoyar la regeneración y mejorar la salud del cuero cabelludo después de la cirugía. 
          </li>
        </ul>
        {/* <Typography className="description mt-10px">
          Next Steps: Access Prescription - Only Treatment
        </Typography> */}
      </>
    ),
    male_what_to_stage6 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Qué esperar </h3>
          </div>
          <ul>
            <li>
              Después de una sesión de trasplante, la cobertura puede asemejarse a la de un Norwood 3 o 4. 
            </li>
            <li>
              Para lograr mayor densidad, pueden requerirse sesiones adicionales.  
            </li>
            <li>
              Para mantener los resultados y proteger los folículos trasplantados, los bloqueadores de DHT recetados pueden ayudar a preservar la zona donante y garantizar que los injertos trasplantados permanezcan saludables. 
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    // male_timeline_stage6 : (
    //   <Card className="statCard yourPhotossection">
    //      <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <AccessTimeOutlinedIcon className="cameraIcon" />
    //         <h3 className="photoTitle">Expected timeline with treatment </h3>
    //       </div>
    //       <ul>
    //         <li>
    //           Month 1:  density maintained. 
    //         </li>
    //         <li>
    //           Months 3–6:  No visible changes; subtle improvements in follicle strepossible.
    //         </li>
    //         <li>
    //           Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
    //         </li>
    //       </ul>
    //      </CardContent>
    //   </Card>
    // ),
    // male_lifestyle_stage6 : (
    //   <Card className="statCard yourPhotossection">
    //     <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <h3 className="photoTitle">Lifestyle & daily care support </h3>
    //       </div>
    //       <Typography className="description">While surgery and prescription therapy are the cornerstones, lifestyle choices remain important to support outcomes: </Typography>
    //       <ul>
    //         <li>Nutrition: </li>
    //         <ul>
    //           <li> Biotin — egg yolks, almonds, peanuts, sweet potatoes</li>
    //           <li>Zinc — lentils, cashews, chickpeas, oysters</li>
    //           <li>Vitamins A, D, and E — help strengthen scalp and follicle environment </li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li> Scalp Stimulation:</li>
    //         <ul>
    //           <li>Gentle scalp massage with a silicone massager, 5 minutes daily, improves circulation and aids healing post-transplant.</li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li>Avoid: Smoking, excessive alcohol, chemical styling treatments, and direct trauma to the scalp after surgery. </li>
    //       </ul>
    //       <ul>
    //         <li>Track Progress: Post-transplant regrowth begins at 3–4 months, with major density improvements by 9–12 months. Uploading photos every 3 months through the app ensures accurate tracking. </li>
    //       </ul>
    //     </CardContent>
    //   </Card>
    // ),
    male_legal_stage6 : (
      <Card className="statCard yourPhotossection legalSection stage1">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    male_photos_description_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Tus fotos muestran </h3>
          </div>
          <Typography className="description">
            Tus fotos muestran una calvicie completa en la parte superior del cuero cabelludo: la línea frontal, la zona media y la coronilla están despobladas, dejando solo una franja estrecha de cabello en los laterales y en la parte posterior.  
          </Typography>
          <Typography className="description mt-10px">
            Esta etapa corresponde al Norwood 7, la forma más avanzada de alopecia androgenética. Los tratamientos médicos por sí solos no pueden restaurar la densidad, y las opciones quirúrgicas están limitadas por la cantidad de cabello donante disponible. 
          </Typography>
        </CardContent>
      </Card>
    ),
    male_why_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Por qué ocurre </h3>
          </div>
          <Typography className="description">
            La pérdida de cabello en esta etapa se debe al efecto prolongado de la DHT (dihidrotestosterona) sobre los folículos genéticamente sensibles.  
          </Typography>
          <ul>
            <li>Después de la pubertad, una parte de la testosterona se convierte en DHT mediante las enzimas 5-alfa reductasa tipo I y II. </li>
            <li>
              En los hombres con alopecia androgenética, la DHT se une a los receptores de los folículos situados en la parte superior y frontal del cuero cabelludo. 
            </li>
            <li>
              Con cada ciclo, los folículos se miniaturizan: los cabellos se vuelven más finos y cortos hasta que la producción cesa por completo. 
            </li>
            <li>
              En esta etapa, la mayoría de los folículos de la parte superior están inactivos, mientras que los de los laterales y la parte posterior, resistentes a la DHT, continúan produciendo cabello.  
            </li>    
          </ul>
        </CardContent>
      </Card>
    ),
    male_what_stage7 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">Qué puedes hacer </h3>
        </div>
        <ul>
          <li>
            Trasplante capilar: puede ser una opción si la zona donante es suficiente. Permite recrear parcialmente una línea frontal o mejorar la cobertura.  
          </li>
          <li>Tratamientos médicos: los bloqueadores de DHT pueden ayudar a proteger la zona donante y mejorar la supervivencia de los injertos. </li>
          <li>
            Soluciones no quirúrgicas: 
            <ul>
              <li>
                Micropigmentación capilar (SMP): crea el efecto visual de un cuero cabelludo rapado con mayor densidad. 
              </li>
              <li>
                Prótesis capilares médicas: ofrecen una apariencia de densidad cuando el trasplante no es viable. 
              </li>
            </ul>
          </li>
        </ul>
        {/* <Typography className="description mt-10px">
          Next Steps: Access Prescription - Only Treatment
        </Typography> */}
      </>
    ),
    male_what_to_stage7 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Qué esperar </h3>
          </div>
          <ul>
            <li>
              La cobertura después de un trasplante puede asemejarse a la de un Norwood 4 o 5.  
            </li>
            <li>
              Para lograr un resultado más denso, pueden requerirse múltiples sesiones de trasplante.   
            </li>
            <li>
              Los bloqueadores de DHT recetados pueden ayudar a mantener los resultados, proteger la zona donante y asegurar que los folículos trasplantados permanezcan sanos.  
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    // male_timeline_stage7 : (
    //   <Card className="statCard yourPhotossection">
    //      <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <AccessTimeOutlinedIcon className="cameraIcon" />
    //         <h3 className="photoTitle">Expected timeline with treatment </h3>
    //       </div>
    //       <ul>
    //         <li>
    //           Month 1:  density maintained. 
    //         </li>
    //         <li>
    //           Months 3–6:  No visible changes; subtle improvements in follicle strepossible.
    //         </li>
    //         <li>
    //           Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
    //         </li>
    //       </ul>
    //      </CardContent>
    //   </Card>
    // ),
    // male_lifestyle_stage7 : (
    //   <Card className="statCard yourPhotossection">
    //     <CardContent className="cardContent">
    //       <div className="photoHeader">
    //         <h3 className="photoTitle">Lifestyle & daily care support </h3>
    //       </div>
    //       <Typography className="description">Even in advanced stages, supporting scalp and donor health is valuable:</Typography>
    //       <ul>
    //         <li>Nutrition: </li>
    //         <ul>
    //           <li>Biotin — egg yolks, almonds, peanuts, sweet potatoes</li>
    //           <li>Zinc — oysters, chickpeas, lentils, cashews</li>
    //           <li>Balanced intake of vitamins A, D, and E to support scalp condition</li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li>Scalp Care:</li>
    //         <ul>
    //           <li> 
    //             Keep the scalp moisturized and healthy to reduce dryness and irritation. 
    //           </li>
    //           <li> 
    //             Gentle massage can maintain circulation and support post-surgical recovery if transplantation is attempted. 
    //           </li>
    //         </ul>
    //       </ul>
    //       <ul>
    //         <li>Avoid: Smoking, poor diet, and harsh scalp products that can compromise donor follicle strength. </li>
    //       </ul>
    //       <ul>
    //         <li>Track Progress: Even at Stage 7, continued use of the in-app tracker ensures that scalp condition and any treatment outcomes (transplant, SMP, or systems) are monitored visually. </li>
    //       </ul>
    //     </CardContent>
    //   </Card>
    // ),
    male_legal_stage7 : (
      <Card className="statCard yourPhotossection legalSection stage1">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos reveal no visible thinning. Hair appears full and dense, with the central parting remaining narrow and the scalp well covered.
          </Typography>
          <Typography className="description mt-10px">
            Some women take the test at this stage because of increased shedding or a loss of styling volume, even though thinning is not yet visible. These concerns are important, as they may represent the earliest signals of change. 
          </Typography>
          <Typography className="description mt-10px">
            Women at this stage who begin preventive care are more likely to maintain full density and delay the onset of visible thinning.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            Losing up to 100 hairs per day is normal and should not be a cause for alarm. However, in women with a genetic predisposition, the balance of hormones and follicle sensitivity can gradually change over time. 
          </Typography>
          <ul>
            <li>
              Family history plays an important role. If close female relatives experienced thinning, the risk is higher. </li>
            <li>
              Oestrogen normally protects the follicles. It prolongs the growth phase of the hair cycle and helps maintain density. 
            </li>
            <li>
              After menopause, declining oestrogen levels reduce this protection, and follicles become more vulnerable. 
            </li>
            <li>
              Even though women produce much lower levels of testosterone than men, a small fraction is converted into dihydrotestosterone (DHT).  
            </li>
            <li>
              In sensitive follicles, DHT binds to receptors and begins the process of miniaturisation: hairs grow back finer, the active growth phase shortens, and resting phases lengthen. 
            </li>
            <li>
              Over the years, this cycle can lead to progressive thinning — most often visible along the central parting and crown, which defines the Sinclair pattern of female hair loss. 
            </li>
          </ul>
          <Typography className="description">
            At Stage 1, your hair coverage is still excellent. But understanding these mechanisms explains why early vigilance or preventive treatment is often recommended, especially if there is family history.  
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage0 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>Preventive prescription care can help protect follicles before visible thinning begins.</li>
          <li>Monitoring is an option if you prefer to wait — we recommend repeating the test in 6 months. </li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    female_timeline_stage0 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Shedding may stabilise
            </li>
            <li>
              Month 3–6: Subtle thickening possible 
            </li>
            <li>
              Month 6+: Maintenance of density and delayed onset of thinning 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage0 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs) </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Also include fruits, vegetables, and protein-rich foods. 
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoo (rosemary or lavender extracts may help).</li>
              <li>Massage the scalp gently with a silicone massager. </li>
              <li>Avoid harsh dyes, frequent bleaching, and heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Prioritise sleep and manage stress (yoga, meditation, deep breathing). </li>
              <li>Avoid smoking, which reduces blood flow and accelerates hair loss. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage0 : (
      <Card className="statCard yourPhotossection legalSection stage1">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos reveal mild widening of the central parting, with slightly less density visible compared to Stage 1. Hair remains overall full, but subtle changes in volume may be noticeable when styling. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 2 on the Sinclair scale, often considered the earliest visible stage of female pattern hair loss. Many women first become aware of thinning at this point, particularly when comparing photos or noticing more scalp visibility under bright light. 
          </Typography>
          <Typography className="description mt-10px">
            Women who start medical treatment at Stage 2 often stabilise shedding quickly and preserve visible density long term.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            At Stage 2, the first visible signs of follicle miniaturisation appear. While daily shedding may still be within the normal range, the regrown hairs are no longer the same as those lost: 
          </Typography>
          <ul>
            <li>Hairs grow back finer and shorter, leading to a gradual reduction in volume.</li>
            <li>
              The central parting begins to widen as miniaturised hairs provide less coverage.
            </li>
            <li>
              After menopause, levels of oestrogen and progestogen naturally decline, while male-type hormones (androgens) may exert more influence. 
            </li>
            <li>
              If your follicles are particularly sensitive to these hormones — especially dihydrotestosterone (DHT) — this can trigger or accelerate hair loss. 
            </li>
          </ul>
          <Typography className="description">
            This stage marks the shift from invisible shedding to visible thinning, making it a crucial moment to begin preventive or corrective measures. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage1 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>Prescription anti-androgen therapy can block follicle sensitivity to DHT and preserve thickness. </li>
          <li>Topical or oral treatments may stimulate regrowth of miniaturised hairs.</li>
          <li>Regular monitoring with repeat tests every 2 months will help track stability and guide adjustments.</li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    female_timeline_stage1 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Shedding stabilises 
            </li>
            <li>
              Month 3–6: Visible regrowth and improved density often begin 
            </li>
            <li>
              Months 6–12: Long-term monitoring ensures that any early changesdetected and treated quickly.
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage1 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs)  </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Support with fruits, vegetables, and protein-rich foods.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoos; rosemary or lavender extracts may provide mild supportive benefits. </li>
              <li>Massage the scalp daily with a silicone massager to stimulate blood flow. </li>
              <li>Avoid harsh dyes, chemical treatments, or frequent heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Prioritise sleep and manage stress with yoga, meditation, or relaxation techniques.</li>
              <li>
                Avoid smoking, which worsens microcirculation and accelerates miniaturisation. 
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage1 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a noticeable widening of the central parting, with the scalp more visible compared to Stage 2. Hair density in the frontal and crown regions appears reduced, though overall coverage remains. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 3 on the Sinclair scale, where thinning becomes obvious under normal lighting conditions. Many women at this stage report difficulty maintaining the same hairstyles, reduced volume, and more visible scalp in photos.
          </Typography>
          <Typography className="description mt-10px">
            Women at Stage 3 who start treatment often see significant improvement in density within 6–12 months.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            At Stage 3, the process of follicle miniaturisation becomes much more visible. 
          </Typography>
          <ul>
            <li>
              The scalp shows clearly through the central parting, and thinning is noticeable in normal lighting. 
            </li>
            <li>
              Miniaturised hairs are thinner and shorter, which reduces their ability to provide volume and coverage.
            </li>
            <li>
              After menopause, the decline in oestrogen and progestogen removes much of the natural protection that previously helped maintain density. 
            </li>
            <li>
              This shift allows androgens, particularly dihydrotestosterone (DHT), to play a more prominent role, further accelerating the miniaturisation process.  
            </li>
            <li>
              The hair cycle becomes imbalanced: the growth phase shortens, while the resting phase lengthens, resulting in continuous shedding without full replacement. 
            </li>
            <li>
              This is a widespread process: over 40% of women experience some form of alopecia after menopause, showing how common and hormonally driven this condition is. 
            </li>
          </ul>
          <Typography className="description">
            At Stage 3, the process is still highly manageable with treatment — but if ignored, progression to more advanced stages becomes likely. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage2 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>Prescription anti-androgen therapies (oral or topical) can significantly slow or halt progression. </li>
          <li>Combination approaches (medical + supportive care) give the best chance of visible thickening. </li>
          <li>Follow-up testing every 2 months is recommended to track changes and adjust treatment. </li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    female_timeline_stage2 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Stabilisation of shedding 
            </li>
            <li>
              Month 3–6: New regrowth begins to appear 
            </li>
            <li>
              Month 6–12: Visible thickening, improved volume, and reduction in scalp visibility 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage2 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs) </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Support with fruits, vegetables, and protein-based meals.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>Use sulphate-free shampoos; natural options with rosemary or lavender may support scalp health. </li>
              <li>Perform gentle scalp massage daily to stimulate circulation (unless using prescription topicals). </li>
              <li>Avoid harsh chemical treatments and high-heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Ensure adequate sleep and manage stress through yoga, meditation, or relaxation.  </li>
              <li>
                Do not smoke, as it reduces scalp blood flow and accelerates miniaturisation. 
              </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage2 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos reveal a marked widening of the central parting, with the scalp clearly visible. Hair in the crown and mid-frontal areas shows reduced density, though lateral and occipital (back) regions remain well preserved. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 4 on the Sinclair scale, where thinning is significant enough to be noticed in casual settings, often causing distress and changes in hairstyle to mask scalp visibility. 
          </Typography>
          <Typography className="description mt-10px">
            Women at Stage 4 who commit to medical treatment often stabilise progression and achieve visible thickening within 6–12 months.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            By Stage 4, the process of follicle miniaturisation has advanced significantly. 
          </Typography>
          <ul>
            <li>The central parting is markedly widened, and thinning now extends beyond the midline into surrounding areas of the scalp. </li>
            <li>
              Miniaturised hairs dominate, producing strands that are progressively finer, weaker, and less pigmented. 
            </li>
            <li>
              With the continued decline of oestrogen and progestogen, follicles lose their natural hormonal protection, leaving them increasingly vulnerable to androgenic influence.  
            </li>
            <li>
              Even at the lower androgen levels typical in women, DHT is sufficient to drive follicular shrinkage, leading to a progressive reduction in both hair thickness and coverage. 
            </li>
            <li>
              The growth cycle becomes more disrupted: fewer hairs enter the anagen (growth) phase, while more shift into telogen (resting), which accelerates visible loss. 
            </li>
            <li>
              By this stage, the process is part of a well-recognised pattern: more than 40% of women will develop alopecia after menopause, reflecting the loss of hormonal protection and increasing follicular vulnerability.
            </li>
          </ul>
          <Typography className="description">
            At this stage, the loss of volume is substantial, and the scalp is conspicuous in most lighting conditions. Intervention is essential to preserve the remaining density and slow further progression. 
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage3 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>Medical treatment is strongly recommended at this stage to preserve remaining active follicles.</li>
          <li>Anti-androgen therapies (oral or topical) help block DHT activity and extend growth phases. </li>
          <li>Combination therapy — prescription + lifestyle measures — offers the best chance of visible recovery. </li>
          <li>Ongoing monitoring with repeat tests every 2 months is essential to track treatment effectiveness. </li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    female_timeline_stage3 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Stabilisation of shedding 
            </li>
            <li>
              Month 3–6: Thickening of miniaturised hairs 
            </li>
            <li>
              Month 6–12: Visible improvement in scalp coverage and parting density 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage3 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs)  </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish)
                Add fresh fruits, vegetables, and protein for balanced support.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>
                Use sulphate-free shampoos; rosemary or lavender extracts may be beneficial. 
              </li>
              <li>Gentle daily scalp massage can support circulation. </li>
              <li>Avoid frequent bleaching, dyes, or excessive heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Ensure adequate sleep and stress reduction practices (yoga, meditation).  </li>
              <li>Avoid smoking, as it impairs microcirculation and accelerates miniaturisation. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage3 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
    female_photos_description_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <CameraAltOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Your photos show</h3>
          </div>
          <Typography className="description">
            Your photos reveal severe widening of the central parting, with large areas of scalp visible. The crown and mid-frontal zones are extensively affected, though the back and sides remain relatively preserved. 
          </Typography>
          <Typography className="description mt-10px">
            This corresponds to Stage 5 on the Sinclair scale, where thinning is obvious in all lighting conditions. Many women at this stage experience loss of volume, difficulty styling, and a strong emotional impact due to the visibility of the condition. 
          </Typography>
          <Typography className="description mt-10px">
            Women who begin medical treatment at Stage 5 may still achieve visible thickening, but preserving the remaining follicles is the most urgent goal.
          </Typography>
        </CardContent>
      </Card>
    ),
    female_why_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle"> Why this happens</h3>
          </div>
          <Typography className="description">
            At Stage 5, the process of miniaturisation has reached an advanced level, and the impact on coverage is significant.
          </Typography>
          <ul>
            <li>The central parting is wide and diffuse, with thinning extending well beyond the midline into larger areas of the scalp. </li>
            <li>
              Miniaturised hairs are now the majority, producing strands that are thin, fragile, and often lack pigmentation. 
            </li>
            <li>
              The continued decline of oestrogen and progestogen after menopause removes almost all protective influence on the follicles. 
            </li>
            <li>
              In this context, even modest levels of androgens (particularly DHT) exert a strong effect, accelerating shrinkage and shortening the growth phase. 
            </li>
            <li>
              The anagen (growth) phase is progressively curtailed, while the telogen (resting) phase dominates, leading to a steady reduction in hair count and quality.
            </li>
            <li>
              By this stage, many follicles enter a prolonged dormancy, and some may cease producing visible hairs altogether. 
            </li>
          </ul>
          <Typography className="description">
            This explains why Stage 5 represents a severe form of female pattern hair loss. The scalp is highly visible in nearly all lighting conditions, and spontaneous recovery is unlikely. Medical intervention is essential at this point to maintain remaining density and prevent further irreversible progression.  
          </Typography>
        </CardContent>
      </Card>
    ),
    female_what_stage4 : (
      <>
        <div className="photoHeader">
          <TaskAltOutlinedIcon />
          <h3 className="photoTitle">What you can do</h3>
        </div>
        <ul>
          <li>Immediate medical treatment is strongly advised. Prescription therapies can reduce androgen sensitivity and reactivate dormant follicles. </li>
          <li>Combination therapy (systemic + topical anti-androgens, plus supportive care) offers the best chance of visible improvement. </li>
          <li>Regular monitoring every 2 months is necessary to track progress and adjust treatment.</li>
        </ul>
        <Typography className="description mt-10px">
          {/* Next Steps: Access Prescription - Only Treatment */}
          Next Steps: Proceed
        </Typography>
      </>
    ),
    female_timeline_stage4 : (
      <Card className="statCard yourPhotossection">
         <CardContent className="cardContent">
          <div className="photoHeader">
            <AccessTimeOutlinedIcon className="cameraIcon" />
            <h3 className="photoTitle">Expected timeline with treatment </h3>
          </div>
          <ul>
            <li>
              Month 1–2: Stabilisation of shedding  
            </li>
            <li>
              Month 3–6: Reactivation of weakened follicles, with early regrowth 
            </li>
            <li>
              Month 6–12: Visible thickening and improved scalp coverage, though full restoration may not be possible 
            </li>
          </ul>
         </CardContent>
      </Card>
    ),
    female_lifestyle_stage4 : (
      <Card className="statCard yourPhotossection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Lifestyle & daily care support </h3>
          </div>
          <ul>
            <li>Nutrition: </li>
            <ul>
              <li>Iron (spinach, lentils, red meat) </li>
              <li>Vitamin D + Calcium (oily fish, dairy, eggs) </li>
              <li>
                Biotin & Zinc (almonds, chickpeas, shellfish) 
                Balanced diet with fruits, vegetables, and protein-rich foods is essential.
              </li>
            </ul>
          </ul>
          <ul>
            <li> Scalp Care </li>
            <ul>
              <li>
                Stick to sulphate-free shampoos, ideally with natural supportive ingredients. 
              </li>
              <li>Gentle scalp massage daily can improve circulation, unless contraindicated by topical therapy. </li>
              <li>Avoid frequent bleaching, dyes, or heavy heat styling. </li>
            </ul>
          </ul>
          <ul>
            <li> Wellness </li>
            <ul>
              <li>Maintain regular sleep cycles and manage stress through meditation or yoga. </li>
              <li>Quit smoking, as it reduces blood flow and accelerates follicle loss. </li>
            </ul>
          </ul>
        </CardContent>
      </Card>
    ),
    female_legal_stage4 : (
      <Card className="statCard yourPhotossection legalSection">
        <CardContent className="cardContent">
          <div className="photoHeader">
            <h3 className="photoTitle">Legal & AI Disclaimers</h3>
          </div>
          <ul>
            <li>
              This report is generated by AI trained on dermatology image data. Accuracy may be influenced by lighting, hairstyle, or photo quality. 

            </li>
            <li>
              Only a licensed doctor can make a diagnosis and prescribe a treatment.
            </li>
            <li>
              Mentioned treatments are prescription-only and will be compounded through authorised pharmacies.
            </li>
            <li>
              Your images are anonymised and face-masked. They will only be stored if you explicitly consent for research purposes. 
            </li>
            <li>
              Individual results vary.  No outcome can be guaranteed.
            </li>
          </ul>
        </CardContent>
      </Card>
    ),
  })

  return (
    <>
      {locale && locale === "fr"
        ? masterJsonFr[keyName]
        : locale === "es"
        ? masterJsonEs[keyName]
        : masterJsonEn[keyName]}
    </>
  );
}

export default ReportContentMaster